// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, json } from "react-router-dom"
// import Header from "../Header";
// import { Table, Input, Button, Popconfirm } from "antd";
// import { FetchBatchData, UpdateSingleClassOfBatch, updateBatchStatus } from "../../api/aws-api";
// import { ClassicSpinner, CombSpinner, MagicSpinner } from "react-spinners-kit";
// import Swal from 'sweetalert2'
// import { gapi } from 'gapi-script';
// import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";
// import { FetchStudentDetails } from "../../api/aws-api";





// const EditBatch = ({ meetLink }) => {
//   const [status, setStatus] = useState("")
//   const [classstatus, setClassStatus] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [meetlink, setMeetLink] = useState()
//   const [startDateTime, setStartDateTime] = useState()
//   const [endDateTime, setEndDateTime] = useState()
//   const [editDate, setEditDate] = useState()
//   const [signedIn, setSignedIn] = useState(false);
//   const [gmeetLink, setgMeetLink] = useState('');
//   const [calenderEvents, setCalenderEvents] = useState()
//   const [selectedClass, setSelectedClass] = useState()
//   const [editmeetlink, setEditMeetLink] = useState(false)
//   const [editbatchstatus, setEditBatchStatus] = useState(false)
//   const location = useLocation();
//   const [batchdetails, setBatchDetails] = useState()
//   const navigate = useNavigate()
//   const [userType, setUserType] = useState("")
//   const [addStudentClicked, setAddStudentClicked] = useState(false)
//   const [studentDetails, setStudentDetails] = useState([])
//   const [addedStudentsToTheBatch, setAddedStudentToTheBatch] = useState([])
//   const [isCompletedVisible, setIsCompletedVisible] = useState(false);

//   const [addedStudents, setAddedStudents] = useState([])


//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [searchValue, setSearchValue] = useState('');
//   const [filteredData, setFilteredData] = useState([]);
//   const [preselectedStudents, setPreSelectedStudents] = useState()
//   const [enableSubmitAddStudentButton, setEnableSubmitAddStudentButton] = useState(false)
//   const [studentsAlreadyInBatch, setStudentsAlreadyInBatch] = useState()
//   const [meetEventId, setMeetEventId] = useState("")
//   const [mentorMailId, setMentorMailId] = useState("")
//   const [matchingId, setMatchingId] = useState("");
//   const [studentsMail, setStudentsMail] = useState();


//   const CLIENT_ID = '347764156937-klkgu25nrg2l7pq8iticmrvha29f3vr7.apps.googleusercontent.com';
//   const API_KEY = 'AIzaSyCio8YcxXtf28_wN_ZWIHIjrlmzjGbXTJg';
//   const SCOPES = 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/admin.reports.audit.readonly';



//   useEffect(() => {


//     // function start() {
//     //   gapi.client.init({
//     //     apiKey: API_KEY,
//     //     clientId: CLIENT_ID,
//     //     scope: SCOPES,
//     //   }).then(() => {
//     //     console.log("Google API initialized successfully.");
//     //     gapi.client.load('calendar', 'v3'); // Load the Calendar API library
//     //     const authInstance = gapi.auth2.getAuthInstance();
//     //     authInstance.signIn();
//     //     setSignedIn(authInstance.isSignedIn.get());
//     //     authInstance.isSignedIn.listen(setSignedIn);
//     //   }).catch(error => {
//     //     console.error("Error initializing Google API:", error);
//     //   });
//     // }

//     // gapi.load('client:auth2', start);




//     // console.log("the stored data is", storedData)
//     // if (storedData !== "undefined" && storedData !== "null" && storedData !== undefined && storedData !== null) { setCourseOptions(JSON.parse(storedData)) }
//     const { batch } = location.state ? location.state : []

//     const selectedBatchSession = sessionStorage.getItem("selectedBatch")

//     selectedBatchSession ? setBatchDetails(JSON.parse(selectedBatchSession)) : setBatchDetails(batch)

//     // console.log("sessionBatch in local",JSON.parse(selectedBatchSession))
//     // setBatchDetails(batch)

//     const extractedPart = batch.ClassSchedule[0].meet_link



//     console.log("the batch is", batch);

//     console.log("the batch in the editbatch  is", extractedPart)

//     // const mentorDetails = JSON.parse(batch)
//     // console.log("mentorDetails", mentorDetails);
//     const filteredBatch = batch
//     console.log("the batch in the editbatch  is", filteredBatch)
//     const mentorDetails = batch.mentorName;
//     console.log(mentorDetails, "mentor details");
//     setMeetEventId(extractedPart)
//     setMentorMailId('bharathmanojdev@gmail.com')
//     const type = JSON.parse(sessionStorage.getItem("UserData"))
//     setUserType(type.user_type)
//     fetchStudentDetails()
//     console.log("fgfdgfdgfdgdgfdgfd", batch.EventId)


//     const studentsAlreadyEnrolled = selectedBatchSession ? JSON.parse(selectedBatchSession).StudentsEndrolled.map((ele) => {
//       return ele.key
//     }) : batch.StudentsEndrolled.map((ele) => {
//       return ele.key
//     })

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//     console.log("batccjhh", studentsAlreadyEnrolled)
//     setPreSelectedStudents(studentsAlreadyEnrolled)
//     console.log(preselectedStudents, "preselcted");
//     setSelectedRowKeys(studentsAlreadyEnrolled)
//     console.log(selectedRowKeys, "selectedRows");

//     getBatchDatas()

//   }, [])

//   useEffect(() => {
//     if (batchdetails && batchdetails.ClassSchedule) {
//       const allCompleted = batchdetails.ClassSchedule.every(
//         (item) => item.status === "Completed"
//       );
//       setIsCompletedVisible(allCompleted);
//     }
//   }, [batchdetails]);

//   useEffect(() => {
//     console.log("Updated students' emails:", studentsMail);
//   }, [studentsMail]);


//   const getBatchDatas = async () => {
//     const responsedata = await ConstructorEventGet(FetchBatchData, { "mentorId": "" })
//     console.log("the response data is ", responsedata
//     )


//     const removeCancelledBatches = responsedata.filter((ele) => {
//       return ele.batchProgress != "Cancelled"
//     })


//     const removeCompletedBatches = removeCancelledBatches.filter((ele) => {
//       return ele.batchProgress != "Completed"
//     })

//     console.log("the batches are", removeCompletedBatches)

//     const finalData = removeCompletedBatches.map((ele) => {
//       return ele.StudentsEndrolled.map((ele) => {
//         return ele.key
//       })
//     })

//     console.log("the final data is", finalData)

//     const studentsId = [...new Set(finalData.flat())]

//     setStudentsAlreadyInBatch(studentsId)
//     console.log("the students enrolled are", studentsId)

//   }

//   const fetchStudentDetails = async () => {
//     const responsedata = await ConstructorEventGet(FetchStudentDetails)
//     setStudentDetails(responsedata)
//     console.log("the rsponse data", responsedata)

//     const studentdata = responsedata.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     console.log("the student data is", studentdata)

//     setFilteredData(studentdata)
//     setStudentDetails(studentdata)
//     // setFilteredData(responsedata)
//   }


//   const removeStudentFromBatch = (studentKey) => {
//     console.log("meeting link used to find id ", meetEventId);

//     gapi.client.calendar.events.list({
//       calendarId: 'primary',
//     }).then(response => {
//       console.log("All events:", response.result.items);
//       const events = response.result.items;
//       const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//       if (matchingEvent) {
//         console.log("Matching event ID:", matchingEvent.id);
//         setMatchingId(matchingEvent.id);
//         // You can now use matchingEvent.id as needed
//       } else {
//         console.log("No event found with the provided meet link.");
//       }
//     }).catch(error => {
//       console.error("Error fetching events:", error);
//     });

//     console.log("the key will be", studentKey, "and the batch details is", batchdetails);




//     const deleteStudent = batchdetails.StudentsEndrolled.filter((ele) => {
//       return ele.key != studentKey
//     })
//     batchdetails.StudentsEndrolled = deleteStudent
//     setBatchDetails(batchdetails)
//     const student = batchdetails.StudentsEndrolled.map((ele) => {
//       return ele.key
//     })
//     setPreSelectedStudents(student)
//     console.log(preselectedStudents, "hi pre");

//     setSelectedRowKeys(student)
//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "batchProgress": batchdetails.batchProgress,
//       "StudentsEndrolled": batchdetails.StudentsEndrolled,
//       "BatchId": batchdetails.BatchId,
//       "mentorId": batchdetails.mentorId,
//       "mentorName": batchdetails.mentorName,
//       "courseId": batchdetails.courseId,
//       "courseName": batchdetails.courseName,
//       "isStudentRemoved": true,
//       "studentId": studentKey
//     }
//     updateDatainCloudForRemove(params)
//     setSelectedRows([])
//     setSearchValue("")
//     setFilteredData(studentDetails)
//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)


//   };





//   const enrolledrowSelection = {




//     selectedRowKeys,
//     onChange: (selectedKeys, selectedRecords) => {

//       console.log("the selected keys are", selectedKeys)
//       const storedEnrolledStudents = JSON.parse(localStorage.getItem("studentsAlreadyEnrolled")) || [];
//       console.log("storedEnroled", storedEnrolledStudents);

//       // Combine initially enrolled and newly selected students
//       const updatedSelectedKeys = Array.from(new Set([...storedEnrolledStudents, ...selectedKeys]));
//       setEnableSubmitAddStudentButton(true)
//       setSelectedRowKeys(updatedSelectedKeys);
//       console.log(updatedSelectedKeys, "selcted roew key 1");

//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(updatedSelectedKeys));

//       const updatedSelectedRecords = updatedSelectedKeys.map(key =>
//         studentDetails.find(student => student.key === key)
//       ).filter(record => record); // Filter out any undefined records in case of missing keys

//       // Set updated selected records to state
//       setSelectedRows(updatedSelectedRecords);
//       // Printing the selected row data
//       updatedSelectedRecords.forEach(row => {
//         console.log(`Selected Name: ${row.name}`);
//       });
//     },
//     getCheckboxProps: (record) => ({
//       disabled: studentsAlreadyInBatch.includes(record.key), // Disable checkbox if the student is preselected
//     }),
//   };

//   const handleSearch = (e) => {
//     setSearchValue(e.target.value)

//     const userStudents = studentDetails.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     const searchedValue = userStudents.filter((ele) => {
//       return ele.name.toLowerCase().includes(e.target.value.toLowerCase()) || ele.mobile.includes(e.target.value)
//     })
//     setFilteredData(searchedValue)
//   };

//   const columns = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Email",
//       dataIndex: "email",
//     },
//     {
//       title: "Phone",
//       dataIndex: "mobile",
//     },
//     ...(batchdetails && batchdetails.batchProgress !== "Completed"
//       ? [
//         {
//           title: 'Action',
//           key: 'action',
//           render: (_, record) => (
//             <Popconfirm
//               title="Are you sure you want to delete this student?"
//               onConfirm={() => removeStudentFromBatch(record.key)}
//               okButtonProps={{ className: 'popconfirm-ok-button' }}
//             >
//               <Button type="primary" style={{ backgroundColor: "red" }}>
//                 Remove
//               </Button>
//             </Popconfirm>
//           ),
//         },
//       ]
//       : [])
//   ];

//   const columnss = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//   ]
//   const columnsClassSchedule = [
//     {
//       title: "Class Id",
//       dataIndex: "scheduleNumber",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Start",
//       dataIndex: "startDateTime",
//     },
//     {
//       title: "End",
//       dataIndex: "endDateTime",
//     },
//     {
//       title: "Meet Link",
//       dataIndex: "meet_link",
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//     }
//   ];

//   const savechanges = async () => {
//     console.log("start and enddate is", editDate)

//     const editDatee = editDate.split("T")[0]
//     // const startTime = startDateTime.split("T")[1]
//     // const endTime = endDateTime.split("T")[1]

//     // console.log("the editDate", editDatee)
//     console.log("startTime", startDateTime)
//     console.log("endTime", endDateTime)
//     // console.log("sttt", `${editDate}T${startTime}`)
//     // console.log("sttt", `${editDate}T${endTime}`)

//     const editedStartedDate = `${editDatee}T${startDateTime}:00`
//     const editedEndDate = `${editDatee}T${endDateTime}:00`


//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "meet_link": meetlink,
//       "scheduleNumber": selectedClass.scheduleNumber,
//       "status": classstatus,
//       "startDateTime": editedStartedDate,
//       "endDateTime": editedEndDate
//     }
//     setLoading(true)
//     const responsedata = await ConstructorEventPost(UpdateSingleClassOfBatch, params)
//     if (responsedata[0] === "updated") { setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setSelectedClass(""); setMeetLink(""); setClassStatus(""); setEditDate(""); setStartDateTime(""); setEndDateTime(""); }
//     else { setLoading(false) }
//   }
//   const updateDatainCloud = async (params) => {

//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       console.log("the response data in adding batchstatus is", responsedata[1]);

//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1])); setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setStatus("")
//     }
//     else { setLoading(false) }

//   }
//   const updateDatainCloudForRemove = async (params) => {

//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       console.log("the response data in adding batchstatus is", responsedata[1]);

//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1])); setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setStatus("")

//       const enrolledStudentsMail = batchdetails.StudentsEndrolled.map(student => ({
//         email: student.email,
//       }));

//       console.log("Enrolled students in the required format:", enrolledStudentsMail);

      

      
//   gapi.client.calendar.events.list({
//     calendarId: 'primary',
//   }).then(response => {
//     console.log("All events:", response.result.items);
//     const events = response.result.items;
//     const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//     if (matchingEvent) {
//       console.log("Matching event ID:", matchingEvent.id);
//       const matchingId = matchingEvent.id;


      
//       // Update the event with new attendees
//       gapi.client.calendar.events.patch({
//         calendarId: 'primary',
//         eventId: matchingId,
//         resource: {
//           attendees: enrolledStudentsMail,
//         },
  
//       }).then(updatedResponse => {
//         console.log('Updated event:', updatedResponse.result);
//       }).catch(error => {
//         console.error('Error updating attendees:', error);
//       });
  
  
  
//       // You can now use matchingEvent.id as needed
//     } else {
//       console.log("No event found with the provided meet link.");
//     }
//   }).catch(error => {
//     console.error("Error fetching events:", error);
//   });


//     }
//     else { setLoading(false) }

//   }
//   // const UpdateBatchProgress = (statusupdate) => {


//   //   const params = {
//   //     "mentorId": batchdetails.mentorId,
//   //     "BatchName": batchdetails.BatchName,
//   //     "batchProgress": statusupdate,
//   //     "StudentsEndrolled": batchdetails.StudentsEndrolled
//   //   }
//   //   Swal.fire({
//   //     title: statusupdate === "Cancelled" ? "Do you wish to cancel this batch?" :
//   //       statusupdate === "InProgress" ? "Would you like to switch the status of this batch to in progress?" : statusupdate === "Completed" ? "Would you like to switch the status of this batch to Completed ?" : "",
//   //     text: statusupdate === "Cancelled" ? "Cancel " + batchdetails.BatchName + " ?" :
//   //       statusupdate === "InProgress" ? "Started " + batchdetails.BatchName + " ?" : statusupdate === "Completed" ? "Completed" + batchdetails.BatchName + " ?" : "",
//   //     icon: statusupdate === "InProgress" ? "success" : statusupdate === "Completed" ? "success" : "warning",
//   //     iconColor: statusupdate === "InProgress" ? "#4df766" : statusupdate === "Completed" ? "#4df766" : "#fa414a",
//   //     confirmButtonText: 'Yes, please',
//   //     confirmButtonColor: "#FF7E84",
//   //     cancelButtonColor: "#30BEAD",
//   //     showCancelButton: true,
//   //     cancelButtonText: "Nope,Changed my mind",
//   //   }).then((result) => {
//   //     if (result.isConfirmed) {
//   //       updateDatainCloud(params)

//   //       // if (statusupdate === "InProgress") {
//   //       //   Swal.fire({
//   //       //     title: 'Meet Link',
//   //       //     html: `<input id="swal-input" type="text" class="swal2-input from-control-1" value="${gmeetLink}" readonly>`,
//   //       //     showCancelButton: true,
//   //       //     confirmButtonText: 'Proceed',
//   //       //     cancelButtonText: 'Cancel',
//   //       //     confirmButtonColor: "#FF7E84",
//   //       //     cancelButtonColor: "#30BEAD",
//   //       //     preConfirm: () => {
//   //       //       const input = document.getElementById('swal-input');
//   //       //       if (input) {
//   //       //         params["meet_link"] = input.value;
//   //       //       }
//   //       //     }
//   //       //   }).then((confirm) => {
//   //       //     if (confirm.isConfirmed) {
//   //       //       updateDatainCloud(params);
//   //       //     }
//   //       //   });

//   //       // }
//   //       // else { updateDatainCloud(params) }
//   //     }
//   //   });
//   // }
//   const UpdateBatchProgress = (statusupdate) => {

//   const params = {
//     mentorId: batchdetails.mentorId,
//     BatchName: batchdetails.BatchName,
//     batchProgress: statusupdate,
//     StudentsEndrolled: batchdetails.StudentsEndrolled
//   };

//   Swal.fire({
//     title:
//       statusupdate === "Cancelled"
//         ? "Do you wish to cancel this batch?"
//         : statusupdate === "InProgress"
//         ? "Would you like to switch the status of this batch to In Progress?"
//         : statusupdate === "Completed"
//         ? "Would you like to switch the status of this batch to Completed?"
//         : "",

//     text:
//       statusupdate === "Cancelled"
//         ? `Cancel ${batchdetails.BatchName} ?`
//         : statusupdate === "InProgress"
//         ? `Start ${batchdetails.BatchName} ?`
//         : statusupdate === "Completed"
//         ? `Complete ${batchdetails.BatchName} ?`
//         : "",

//     icon:
//       statusupdate === "InProgress" || statusupdate === "Completed"
//         ? "success"
//         : "warning",

//     iconColor:
//       statusupdate === "InProgress" || statusupdate === "Completed"
//         ? "#4df766"
//         : "#fa414a",

//     showCancelButton: true,
//     confirmButtonText: "Yes, please",
//     cancelButtonText: "Nope, Changed my mind",

//     buttonsStyling: false,
//     customClass: {
//       confirmButton: "my-confirm-btn",
//       cancelButton: "my-cancel-btn"
//     }

//   }).then((result) => {
//     if (result.isConfirmed) {
//       updateDatainCloud(params);
//     }
//   });
// };

//   const selectStudent = () => {
//     setAddStudentClicked(true)
//   }


//   const addStudentToTheBatch = () => {

//     console.log("meeting link used to find id ", meetEventId);

//     gapi.client.calendar.events.list({
//       calendarId: 'primary',
//     }).then(response => {
//       console.log("All events:", response.result.items);
//       const events = response.result.items;
//       const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//       if (matchingEvent) {
//         console.log("Matching event ID:", matchingEvent.id);
//         const matchingId = matchingEvent.id;


//         const updatedAttendees = newlyAddedStudentsToTheBatch.map((ele) => {
//           return { 'email': ele.email }
//         })
    
//         updatedAttendees.push({ 'email': mentorMailId })
    
//         console.log("the updatedAttendees are", updatedAttendees)
    
//         // Update the event with new attendees
//         gapi.client.calendar.events.patch({
//           calendarId: 'primary',
//           eventId: matchingId,
//           resource: {
//             attendees: updatedAttendees,
//           },
    
//         }).then(updatedResponse => {
//           console.log('Updated event:', updatedResponse.result);
//         }).catch(error => {
//           console.error('Error updating attendees:', error);
//         });
    
    
    
//         // You can now use matchingEvent.id as needed
//       } else {
//         console.log("No event found with the provided meet link.");
//       }
//     }).catch(error => {
//       console.error("Error fetching events:", error);
//     });

    

   
//     const newlyAddedStudentsToTheBatch = [...selectedRows]
//     console.log("tttttt", newlyAddedStudentsToTheBatch)

//     const newlyAddedStudents = newlyAddedStudentsToTheBatch.map((ele) => {
//       return ele.key
//     })

//     console.log("newly selected Students", newlyAddedStudents)
//     console.log("prestudent", preselectedStudents);

//     console.log(`the batch id is ${batchdetails.BatchId} the mentor id is ${batchdetails.mentorId} the mentor name is ${batchdetails.mentorName} the course id is ${batchdetails.courseId} the course name is ${batchdetails.courseName}`)
//     setPreSelectedStudents(newlyAddedStudents)
//     setAddedStudentToTheBatch(newlyAddedStudentsToTheBatch)
//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "batchProgress": batchdetails.batchProgress,
//       "StudentsEndrolled": newlyAddedStudentsToTheBatch,
//       "BatchId": batchdetails.BatchId,
//       "mentorId": batchdetails.mentorId,
//       "mentorName": batchdetails.mentorName,
//       "courseId": batchdetails.courseId,
//       "courseName": batchdetails.courseName,
//       "isStudentAdded": true
//     }
//     console.log("the params is", params)
//     updateDatainCloud(params)
//     console.log("newly students enrolled", newlyAddedStudentsToTheBatch)
//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedStudents));

//     setSelectedRows([])
//     setSearchValue("")
//     setFilteredData(studentDetails)
//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }


//   const cancelAddingStudentToTheBatch = () => {
//     const preselectedKeys = selectedRowKeys.filter((key) => preselectedStudents.includes(key));
//     console.log(preselectedKeys, "preselectedkeys")

//     const preselectedRecords = selectedRows.filter((row) => preselectedStudents.includes(row.key));

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedKeys));

//     // Reset the selected keys and rows to only include the preselected students
//     setSelectedRowKeys(preselectedKeys);
//     setSelectedRows(preselectedRecords);

//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }

//   const cancelEditChanges = () => {
//     setEditDate("")
//     setMeetLink("")
//     setStartDateTime("")
//     setEditMeetLink(false)
//   }
// const sweetAlertStyles = `
// .my-confirm-btn {
//   background-color: #FF7E84 !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
//   margin-right: 10px !important;
// }

// .my-cancel-btn {
//   background-color: #30BEAD !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
// }

// .my-confirm-btn:hover,
// .my-cancel-btn:hover {
//   opacity: 0.9;
// }

// .swal2-actions {
//   gap: 12px !important;
// }
// `;

//   return (
//     <>
//       <style>{sweetAlertStyles}</style>
//       <Header />
//       {loading ?
//         <div className="spinner" >
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={loading} />
//           </div></div> :
//         <div className="nav-tab-wrapper tabs  section-padding">
//           <div className="container">
//             <div className="grid grid-cols-12 gap-[30px]">
//               <div className="xl:col-span-4 lg:col-span-6 col-span-12 ">
//                 <div className="mini-title">Edit Your Batch</div>
//                 <div className="bg-white shadow-box7 p-4 rounded-md mt-8">
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Course Name : {batchdetails && batchdetails.courseName}
//                   </div>
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Date : {batchdetails && batchdetails.StartDate} {"   →   "}{batchdetails && batchdetails.EndDate}
//                     {/* ({batchdetails && batchdetails.Repeat}) */}
//                   </div>
//                   {/* <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Time : {batchdetails && batchdetails.StartTime} {"   →   "}{batchdetails && batchdetails.EndTime}
//                   </div> */}
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Mentor : {batchdetails && batchdetails.mentorName}
//                   </div>
//                   {/* {editbatchstatus ?
//                     <div className="pb-4 mt-4"> Status</div>
//                     : */}
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Batch Status : {batchdetails && batchdetails.batchProgress}
//                   </div>
//                   {!editmeetlink && !editbatchstatus ?
//                     <div>
//                       <div style={{ display: "flex" }}>
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditMeetLink(true)}>Edit Class</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "Scheduled" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Change Status</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Edit Batch Status</button> : ""}
//                         {!addStudentClicked && userType === "admin" && batchdetails &&
//                           (batchdetails.batchProgress === "Scheduled" || batchdetails.batchProgress === "InProgress") ? (
//                           <button className="btn btn-secondary mt-4 mr-4" onClick={selectStudent}>
//                             Add Student
//                           </button>
//                         ) : ""}


//                       </div>
//                       {userType === "admin" ? addStudentClicked && enableSubmitAddStudentButton ? <button className="btn btn-secondary mt-4 mr-4" onClick={addStudentToTheBatch}>Submit</button> : "" : ""}
//                       {userType === "admin" ? addStudentClicked ? <button className="btn btn-secondary mt-4 mr-4" onClick={cancelAddingStudentToTheBatch}>Cancel</button> : "" : ""}


//                     </div>
//                     : editmeetlink && !editbatchstatus ?
//                       <div>

//                         <select
//                           className="from-control focus:ring-0 mt-4 bg-[#ECECEC]"
//                           onChange={(e) => {
//                             console.log("tr", e.target.value)
//                             const indclass = e.target.value && batchdetails.ClassSchedule.filter(obj => obj.scheduleNumber === parseInt(e.target.value))[0]; setClassStatus(indclass ? indclass["status"] : ""); setMeetLink(indclass ? indclass["meet_link"] : ""); setStartDateTime(indclass ? indclass["startDateTime"] : ""); setSelectedClass(indclass); setEndDateTime(indclass ? indclass["endDateTime"] : ""); setEditDate(indclass ? indclass["startDateTime"] : "");
//                           }}
//                           required>
//                           <option key="" value="">Select Class</option>
//                           {batchdetails && batchdetails.ClassSchedule.map((item1, index) => (
//                             <option key={item1.scheduleNumber} value={item1.scheduleNumber}>{item1.startDateTime.split("T")[0]}</option>
//                           ))}
//                         </select>
//                         <input
//                           type="date"
//                           className="from-control mt-4"
//                           value={editDate ? editDate.split("T")[0] : ""}
//                           onChange={(e) =>
//                             setEditDate(e.target.value)}
//                         />
//                         <input
//                           type="text"
//                           className="from-control mt-4"
//                           value={meetlink}
//                           placeholder="Meet Link"
//                           onChange={(e) => setMeetLink(e.target.value)}
//                           required
//                           readOnly
//                         />
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={startDateTime ? startDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setStartDateTime(e.target.value)}
//                         />
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={endDateTime ? endDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setEndDateTime(e.target.value)}
//                         />
//                         <div className="input-container">


//                           <select
//                             className="from-control p-4 bg-[#ECECEC] text-[#827878] mt-4"
//                             value={classstatus}
//                             onChange={(e) => setClassStatus(e.target.value)}
//                             required
//                           >
//                             <option key="Scheduled" value="Scheduled">Scheduled</option>
//                             <option key="InProgress" value="InProgress">InProgress</option>
//                             <option key="Completed" value="Completed">Completed</option>
//                           </select>


//                         </div>
//                         {selectedClass ? "" : <button className="btn btn-black mt-4 mr-4" onClick={() => setEditMeetLink(false)}>Cancel</button>}

//                         {selectedClass ? selectedClass.meet_link !== meetlink ?
//                           <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                             <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.status !== classstatus ? <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                               <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.startDateTime.split("T")[0] === editDate ? "" : <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                                 <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : ""}
//                       </div> :
//                       !editmeetlink && editbatchstatus ?
//                         <div>
//                           <div className="input-container">
//                             <select
//                               className="from-control p-4 bg-[#ECECEC] text-[#827878] "
//                               value={status}
//                               onChange={(e) => setStatus(e.target.value)}
//                               required
//                             >
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="" value="">Scheduled</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="InProgress" value="InProgress">InProgress</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}

//                               {batchdetails.batchProgress === "InProgress" ? <option key="" value="">InProgress</option> : ""}
//                               {isCompletedVisible && (
//                                 <option key="Completed" value="Completed">Completed</option>
//                               )}
//                               {batchdetails.batchProgress === "InProgress" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}


//                             </select>


//                           </div>
//                           <button
//                             className=" btn btn-black mr-2 mt-2"
//                             onClick={() => setEditBatchStatus(false)}
//                           >
//                             Cancel
//                           </button>
//                           {status ? <button className="btn btn-black mt-4 mr-4" onClick={() => UpdateBatchProgress(status)}  >Save Changes</button> : ""}
//                         </div >
//                         :
//                         ""
//                   }

//                 </div>

//               </div>
//               <div className="xl:col-span-6 lg:col-span-6 col-span-12">
//                 {addStudentClicked ? <div className="bg-white shadow-box7 p-8 rounded-md">
//                   <Input
//                     placeholder="Search by Name or Phone number"
//                     className="from-control"
//                     value={searchValue}
//                     onChange={handleSearch}
//                     style={{ marginBottom: 16 }}

//                   />
//                   <Table
//                     rowSelection={enrolledrowSelection}
//                     className=""
//                     columns={columnss}
//                     dataSource={filteredData}
//                     pagination={filteredData.length > 9 ? true : false}
//                     rowKey={(record) => record.key}
//                   />
//                 </div>
//                   : <div className="bg-white shadow-box7 p-8 rounded-md">

//                     <Table
//                       className=""
//                       columns={columns}
//                       dataSource={batchdetails && batchdetails.StudentsEndrolled}
//                       pagination={batchdetails && batchdetails.StudentsEndrolled.length > 9 ? true : false}
//                       rowKey={(record) => record.key}
//                     />

//                   </div>}
//               </div>

//             </div>
//             <div className="bg-white shadow-box7 p-8 rounded-md mt-4">
//               <Table
//                 className=""
//                 columns={columnsClassSchedule}
//                 dataSource={batchdetails && batchdetails.ClassSchedule}
//                 pagination={batchdetails && batchdetails.ClassSchedule.length > 9 ? true : false}
//                 rowKey={(record) => record.scheduleNumber}
//               />
//             </div>
//           </div>
//         </div >}

//     </>
//   )

// }
// export default EditBatch;





















// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, json } from "react-router-dom"
// import Header from "../Header";
// import { Table, Input, Button, Popconfirm } from "antd";
// import { FetchBatchData, UpdateSingleClassOfBatch, updateBatchStatus } from "../../api/aws-api";
// import { ClassicSpinner, CombSpinner, MagicSpinner } from "react-spinners-kit";
// import Swal from 'sweetalert2'
// import { gapi } from 'gapi-script';
// import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";
// import { FetchStudentDetails } from "../../api/aws-api";
// // import { FetchMentorDetails } from "../../api/aws-api"; 





// const EditBatch = ({ meetLink }) => {
//   const [status, setStatus] = useState("")
//   const [classstatus, setClassStatus] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [meetlink, setMeetLink] = useState()
//   const [startDateTime, setStartDateTime] = useState()
//   const [endDateTime, setEndDateTime] = useState()
//   const [editDate, setEditDate] = useState()
//   const [signedIn, setSignedIn] = useState(false);
//   const [gmeetLink, setgMeetLink] = useState('');
//   const [calenderEvents, setCalenderEvents] = useState()
//   const [selectedClass, setSelectedClass] = useState()
//   const [editmeetlink, setEditMeetLink] = useState(false)
//   const [editbatchstatus, setEditBatchStatus] = useState(false)
//   const location = useLocation();
//   const [batchdetails, setBatchDetails] = useState()
//   const navigate = useNavigate()
//   const [userType, setUserType] = useState("")
//   const [addStudentClicked, setAddStudentClicked] = useState(false)
//   const [studentDetails, setStudentDetails] = useState([])
//   const [addedStudentsToTheBatch, setAddedStudentToTheBatch] = useState([])
//   const [isCompletedVisible, setIsCompletedVisible] = useState(false);

//   const [addedStudents, setAddedStudents] = useState([])

//   const [mentorMeetLink, setMentorMeetLink] = useState("");


//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [searchValue, setSearchValue] = useState('');
//   const [filteredData, setFilteredData] = useState([]);
//   const [preselectedStudents, setPreSelectedStudents] = useState()
//   const [enableSubmitAddStudentButton, setEnableSubmitAddStudentButton] = useState(false)
//   const [studentsAlreadyInBatch, setStudentsAlreadyInBatch] = useState()
//   const [meetEventId, setMeetEventId] = useState("")
//   const [mentorMailId, setMentorMailId] = useState("")
//   const [matchingId, setMatchingId] = useState("");
//   const [studentsMail, setStudentsMail] = useState();


//   const CLIENT_ID = '347764156937-klkgu25nrg2l7pq8iticmrvha29f3vr7.apps.googleusercontent.com';
//   const API_KEY = 'AIzaSyCio8YcxXtf28_wN_ZWIHIjrlmzjGbXTJg';
//   const SCOPES = 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/admin.reports.audit.readonly';



//   useEffect(() => {


//     // function start() {
//     //   gapi.client.init({
//     //     apiKey: API_KEY,
//     //     clientId: CLIENT_ID,
//     //     scope: SCOPES,
//     //   }).then(() => {
//     //     console.log("Google API initialized successfully.");
//     //     gapi.client.load('calendar', 'v3'); // Load the Calendar API library
//     //     const authInstance = gapi.auth2.getAuthInstance();
//     //     authInstance.signIn();
//     //     setSignedIn(authInstance.isSignedIn.get());
//     //     authInstance.isSignedIn.listen(setSignedIn);
//     //   }).catch(error => {
//     //     console.error("Error initializing Google API:", error);
//     //   });
//     // }

//     // gapi.load('client:auth2', start);




//     // console.log("the stored data is", storedData)
//     // if (storedData !== "undefined" && storedData !== "null" && storedData !== undefined && storedData !== null) { setCourseOptions(JSON.parse(storedData)) }
//     const { batch } = location.state ? location.state : []

//     const selectedBatchSession = sessionStorage.getItem("selectedBatch")

//     selectedBatchSession ? setBatchDetails(JSON.parse(selectedBatchSession)) : setBatchDetails(batch)

//     // console.log("sessionBatch in local",JSON.parse(selectedBatchSession))
//     // setBatchDetails(batch)

//     const extractedPart = batch.ClassSchedule[0].meet_link



//     console.log("the batch is", batch);

//     console.log("the batch in the editbatch  is", extractedPart)

//     // const mentorDetails = JSON.parse(batch)
//     // console.log("mentorDetails", mentorDetails);
//     const filteredBatch = batch
//     console.log("the batch in the editbatch  is", filteredBatch)
//     const mentorDetails = batch.mentorName;
//     console.log(mentorDetails, "mentor details");
//     setMeetEventId(extractedPart)
//     setMentorMailId('bharathmanojdev@gmail.com')
//     const type = JSON.parse(sessionStorage.getItem("UserData"))
//     setUserType(type.user_type)
//     fetchStudentDetails()
//     console.log("fgfdgfdgfdgdgfdgfd", batch.EventId)


//     const studentsAlreadyEnrolled = selectedBatchSession ? JSON.parse(selectedBatchSession).StudentsEndrolled.map((ele) => {
//       return ele.key
//     }) : batch.StudentsEndrolled.map((ele) => {
//       return ele.key
//     })

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//     console.log("batccjhh", studentsAlreadyEnrolled)
//     setPreSelectedStudents(studentsAlreadyEnrolled)
//     console.log(preselectedStudents, "preselcted");
//     setSelectedRowKeys(studentsAlreadyEnrolled)
//     console.log(selectedRowKeys, "selectedRows");

//     getBatchDatas()

//   }, [])

//   useEffect(() => {
//     if (batchdetails && batchdetails.ClassSchedule) {
//       const allCompleted = batchdetails.ClassSchedule.every(
//         (item) => item.status === "Completed"
//       );
//       setIsCompletedVisible(allCompleted);
//     }
//   }, [batchdetails]);

//   useEffect(() => {
//     console.log("Updated students' emails:", studentsMail);
//   }, [studentsMail]);


//   const getBatchDatas = async () => {
//     const responsedata = await ConstructorEventGet(FetchBatchData, { "mentorId": "" })
//     console.log("the response data is ", responsedata
//     )


//     const removeCancelledBatches = responsedata.filter((ele) => {
//       return ele.batchProgress != "Cancelled"
//     })


//     const removeCompletedBatches = removeCancelledBatches.filter((ele) => {
//       return ele.batchProgress != "Completed"
//     })

//     console.log("the batches are", removeCompletedBatches)

//     const finalData = removeCompletedBatches.map((ele) => {
//       return ele.StudentsEndrolled.map((ele) => {
//         return ele.key
//       })
//     })

//     console.log("the final data is", finalData)

//     const studentsId = [...new Set(finalData.flat())]

//     setStudentsAlreadyInBatch(studentsId)
//     console.log("the students enrolled are", studentsId)

//   }

//   const fetchStudentDetails = async () => {
//     const responsedata = await ConstructorEventGet(FetchStudentDetails)
//     setStudentDetails(responsedata)
//     console.log("the rsponse data", responsedata)

//     const studentdata = responsedata.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     console.log("the student data is", studentdata)

//     setFilteredData(studentdata)
//     setStudentDetails(studentdata)
//     // setFilteredData(responsedata)
//   }


//   // const removeStudentFromBatch = (studentKey) => {
//   //   console.log("meeting link used to find id ", meetEventId);

//   //   gapi.client.calendar.events.list({
//   //     calendarId: 'primary',
//   //   }).then(response => {
//   //     console.log("All events:", response.result.items);
//   //     const events = response.result.items;
//   //     const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//   //     if (matchingEvent) {
//   //       console.log("Matching event ID:", matchingEvent.id);
//   //       setMatchingId(matchingEvent.id);
//   //       // You can now use matchingEvent.id as needed
//   //     } else {
//   //       console.log("No event found with the provided meet link.");
//   //     }
//   //   }).catch(error => {
//   //     console.error("Error fetching events:", error);
//   //   });

//   //   console.log("the key will be", studentKey, "and the batch details is", batchdetails);




//   //   const deleteStudent = batchdetails.StudentsEndrolled.filter((ele) => {
//   //     return ele.key != studentKey
//   //   })
//   //   batchdetails.StudentsEndrolled = deleteStudent
//   //   setBatchDetails(batchdetails)
//   //   const student = batchdetails.StudentsEndrolled.map((ele) => {
//   //     return ele.key
//   //   })
//   //   setPreSelectedStudents(student)
//   //   console.log(preselectedStudents, "hi pre");

//   //   setSelectedRowKeys(student)
//   //   const params = {
//   //     "mentorId": batchdetails.mentorId,
//   //     "BatchName": batchdetails.BatchName,
//   //     "batchProgress": batchdetails.batchProgress,
//   //     "StudentsEndrolled": batchdetails.StudentsEndrolled,
//   //     "BatchId": batchdetails.BatchId,
//   //     "mentorId": batchdetails.mentorId,
//   //     "mentorName": batchdetails.mentorName,
//   //     "courseId": batchdetails.courseId,
//   //     "courseName": batchdetails.courseName,
//   //     "isStudentRemoved": true,
//   //     "studentId": studentKey
//   //   }
//   //   updateDatainCloudForRemove(params)
//   //   setSelectedRows([])
//   //   setSearchValue("")
//   //   setFilteredData(studentDetails)
//   //   setAddStudentClicked(false)
//   //   setEnableSubmitAddStudentButton(false)


//   // };


//   const removeStudentFromBatch = (studentKey) => {
//   console.log("the key will be", studentKey);
//   console.log("the batch details is", batchdetails);

//   if (!batchdetails) {
//     console.error("Batch details are not available");
//     return;
//   }

//   const deleteStudent = batchdetails.StudentsEndrolled.filter((ele) => {
//     return ele.key !== studentKey;
//   });

//   const updatedBatchDetails = {
//     ...batchdetails,
//     StudentsEndrolled: deleteStudent,
//   };

//   setBatchDetails(updatedBatchDetails);


//   const fetchMentorMeetLink = async () => {
//     const mentors = await ConstructorEventGet(FetchMentorDetails);
//     const match = mentors.find(m => m.user_id === batch.mentorId);
//     setMentorMeetLink(match ? match.meet_link : "");
//   };
//   fetchMentorMeetLink();

//   // const columnsClassSchedule = [
//   //   { title: "Class Id", dataIndex: "scheduleNumber", sorter: (a, b) => a.name.length - b.name.length },
//   //   { title: "Start", dataIndex: "startDateTime" },
//   //   { title: "End", dataIndex: "endDateTime" },
//   //   { title: "Status", dataIndex: "status" }
//   //   // Meet Link column removed — it's per-mentor now, shown once above the table
//   // ];

//   const student = deleteStudent.map((ele) => ele.key);

//   setPreSelectedStudents(student);
//   setSelectedRowKeys(student);

//   const params = {
//     mentorId: batchdetails.mentorId,
//     BatchName: batchdetails.BatchName,
//     batchProgress: batchdetails.batchProgress,
//     StudentsEndrolled: deleteStudent,
//     BatchId: batchdetails.BatchId,
//     mentorName: batchdetails.mentorName,
//     courseId: batchdetails.courseId,
//     courseName: batchdetails.courseName,
//     isStudentRemoved: true,
//     studentId: studentKey,
//   };

//   updateDatainCloudForRemove(params);

//   setSelectedRows([]);
//   setSearchValue("");
//   setFilteredData(studentDetails);
//   setAddStudentClicked(false);
//   setEnableSubmitAddStudentButton(false);
// };





//   const enrolledrowSelection = {




//     selectedRowKeys,
//     onChange: (selectedKeys, selectedRecords) => {

//       console.log("the selected keys are", selectedKeys)
//       const storedEnrolledStudents = JSON.parse(localStorage.getItem("studentsAlreadyEnrolled")) || [];
//       console.log("storedEnroled", storedEnrolledStudents);

//       // Combine initially enrolled and newly selected students
//       const updatedSelectedKeys = Array.from(new Set([...storedEnrolledStudents, ...selectedKeys]));
//       setEnableSubmitAddStudentButton(true)
//       setSelectedRowKeys(updatedSelectedKeys);
//       console.log(updatedSelectedKeys, "selcted roew key 1");

//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(updatedSelectedKeys));

//       const updatedSelectedRecords = updatedSelectedKeys.map(key =>
//         studentDetails.find(student => student.key === key)
//       ).filter(record => record); // Filter out any undefined records in case of missing keys

//       // Set updated selected records to state
//       setSelectedRows(updatedSelectedRecords);
//       // Printing the selected row data
//       updatedSelectedRecords.forEach(row => {
//         console.log(`Selected Name: ${row.name}`);
//       });
//     },
//     getCheckboxProps: (record) => ({
//       disabled: studentsAlreadyInBatch.includes(record.key), // Disable checkbox if the student is preselected
//     }),
//   };

//   const handleSearch = (e) => {
//     setSearchValue(e.target.value)

//     const userStudents = studentDetails.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     const searchedValue = userStudents.filter((ele) => {
//       return ele.name.toLowerCase().includes(e.target.value.toLowerCase()) || ele.mobile.includes(e.target.value)
//     })
//     setFilteredData(searchedValue)
//   };

//   const columns = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Email",
//       dataIndex: "email",
//     },
//     {
//       title: "Phone",
//       dataIndex: "mobile",
//     },
//     ...(batchdetails && batchdetails.batchProgress !== "Completed"
//       ? [
//         {
//           title: 'Action',
//           key: 'action',
//           render: (_, record) => (
//             <Popconfirm
//               title="Are you sure you want to delete this student?"
//               onConfirm={() => removeStudentFromBatch(record.key)}
//               okButtonProps={{ className: 'popconfirm-ok-button' }}
//             >
//               <Button type="primary" style={{ backgroundColor: "red" }}>
//                 Remove
//               </Button>
//             </Popconfirm>
//           ),
//         },
//       ]
//       : [])
//   ];

//   const columnss = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//   ]
//   const columnsClassSchedule = [
//     {
//       title: "Class Id",
//       dataIndex: "scheduleNumber",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Start",
//       dataIndex: "startDateTime",
//     },
//     {
//       title: "End",
//       dataIndex: "endDateTime",
//     },
//     // {
//     //   title: "Meet Link",
//     //   dataIndex: "meet_link",
//     // },
//     {
//       title: "Status",
//       dataIndex: "status",
//     }
//   ];

//   const savechanges = async () => {
//     console.log("start and enddate is", editDate)

//     const editDatee = editDate.split("T")[0]
//     // const startTime = startDateTime.split("T")[1]
//     // const endTime = endDateTime.split("T")[1]

//     // console.log("the editDate", editDatee)
//     console.log("startTime", startDateTime)
//     console.log("endTime", endDateTime)
//     // console.log("sttt", `${editDate}T${startTime}`)
//     // console.log("sttt", `${editDate}T${endTime}`)

//     const editedStartedDate = `${editDatee}T${startDateTime}:00`
//     const editedEndDate = `${editDatee}T${endDateTime}:00`


//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "meet_link": meetlink,
//       "scheduleNumber": selectedClass.scheduleNumber,
//       "status": classstatus,
//       "startDateTime": editedStartedDate,
//       "endDateTime": editedEndDate
//     }
//     setLoading(true)
//     const responsedata = await ConstructorEventPost(UpdateSingleClassOfBatch, params)
//     if (responsedata[0] === "updated") { setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setSelectedClass(""); setMeetLink(""); setClassStatus(""); setEditDate(""); setStartDateTime(""); setEndDateTime(""); }
//     else { setLoading(false) }
//   }
//   const updateDatainCloud = async (params) => {

//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       console.log("the response data in adding batchstatus is", responsedata[1]);

//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1])); setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setStatus("")
//     }
//     else { setLoading(false) }

//   }
//   const updateDatainCloudForRemove = async (params) => {
//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));
//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1]));
//       setLoading(false);
//       setBatchDetails(responsedata[1]);
//       setEditBatchStatus(false);
//       setEditMeetLink(false);
//       setStatus("")

//       // Guard: gapi.client is never initialized on this page right now
//       // (the init block above is commented out), so this whole sync
//       // step is currently dead. Skip it instead of crashing.
//       if (gapi.client && gapi.client.calendar) {
//         const enrolledStudentsMail = batchdetails.StudentsEndrolled.map(student => ({
//           email: student.email,
//         }));

//         gapi.client.calendar.events.list({ calendarId: 'primary' })
//           .then(response => {
//             const matchingEvent = response.result.items.find(event => event.hangoutLink === meetEventId);
//             if (matchingEvent) {
//               gapi.client.calendar.events.patch({
//                 calendarId: 'primary',
//                 eventId: matchingEvent.id,
//                 resource: { attendees: enrolledStudentsMail },
//               }).catch(error => console.error('Error updating attendees:', error));
//             }
//           })
//           .catch(error => console.error("Error fetching events:", error));
//       } else {
//         console.warn("Skipping calendar attendee sync — Google API client not initialized on this page.");
//       }
//     } else {
//       setLoading(false)
//     }
//   }
//   // const UpdateBatchProgress = (statusupdate) => {


//   //   const params = {
//   //     "mentorId": batchdetails.mentorId,
//   //     "BatchName": batchdetails.BatchName,
//   //     "batchProgress": statusupdate,
//   //     "StudentsEndrolled": batchdetails.StudentsEndrolled
//   //   }
//   //   Swal.fire({
//   //     title: statusupdate === "Cancelled" ? "Do you wish to cancel this batch?" :
//   //       statusupdate === "InProgress" ? "Would you like to switch the status of this batch to in progress?" : statusupdate === "Completed" ? "Would you like to switch the status of this batch to Completed ?" : "",
//   //     text: statusupdate === "Cancelled" ? "Cancel " + batchdetails.BatchName + " ?" :
//   //       statusupdate === "InProgress" ? "Started " + batchdetails.BatchName + " ?" : statusupdate === "Completed" ? "Completed" + batchdetails.BatchName + " ?" : "",
//   //     icon: statusupdate === "InProgress" ? "success" : statusupdate === "Completed" ? "success" : "warning",
//   //     iconColor: statusupdate === "InProgress" ? "#4df766" : statusupdate === "Completed" ? "#4df766" : "#fa414a",
//   //     confirmButtonText: 'Yes, please',
//   //     confirmButtonColor: "#FF7E84",
//   //     cancelButtonColor: "#30BEAD",
//   //     showCancelButton: true,
//   //     cancelButtonText: "Nope,Changed my mind",
//   //   }).then((result) => {
//   //     if (result.isConfirmed) {
//   //       updateDatainCloud(params)

//   //       // if (statusupdate === "InProgress") {
//   //       //   Swal.fire({
//   //       //     title: 'Meet Link',
//   //       //     html: `<input id="swal-input" type="text" class="swal2-input from-control-1" value="${gmeetLink}" readonly>`,
//   //       //     showCancelButton: true,
//   //       //     confirmButtonText: 'Proceed',
//   //       //     cancelButtonText: 'Cancel',
//   //       //     confirmButtonColor: "#FF7E84",
//   //       //     cancelButtonColor: "#30BEAD",
//   //       //     preConfirm: () => {
//   //       //       const input = document.getElementById('swal-input');
//   //       //       if (input) {
//   //       //         params["meet_link"] = input.value;
//   //       //       }
//   //       //     }
//   //       //   }).then((confirm) => {
//   //       //     if (confirm.isConfirmed) {
//   //       //       updateDatainCloud(params);
//   //       //     }
//   //       //   });

//   //       // }
//   //       // else { updateDatainCloud(params) }
//   //     }
//   //   });
//   // }
//   const UpdateBatchProgress = (statusupdate) => {

//   const params = {
//     mentorId: batchdetails.mentorId,
//     BatchName: batchdetails.BatchName,
//     batchProgress: statusupdate,
//     StudentsEndrolled: batchdetails.StudentsEndrolled
//   };

//   Swal.fire({
//     title:
//       statusupdate === "Cancelled"
//         ? "Do you wish to cancel this batch?"
//         : statusupdate === "InProgress"
//         ? "Would you like to switch the status of this batch to In Progress?"
//         : statusupdate === "Completed"
//         ? "Would you like to switch the status of this batch to Completed?"
//         : "",

//     text:
//       statusupdate === "Cancelled"
//         ? `Cancel ${batchdetails.BatchName} ?`
//         : statusupdate === "InProgress"
//         ? `Start ${batchdetails.BatchName} ?`
//         : statusupdate === "Completed"
//         ? `Complete ${batchdetails.BatchName} ?`
//         : "",

//     icon:
//       statusupdate === "InProgress" || statusupdate === "Completed"
//         ? "success"
//         : "warning",

//     iconColor:
//       statusupdate === "InProgress" || statusupdate === "Completed"
//         ? "#4df766"
//         : "#fa414a",

//     showCancelButton: true,
//     confirmButtonText: "Yes, please",
//     cancelButtonText: "Nope, Changed my mind",

//     buttonsStyling: false,
//     customClass: {
//       confirmButton: "my-confirm-btn",
//       cancelButton: "my-cancel-btn"
//     }

//   }).then((result) => {
//     if (result.isConfirmed) {
//       updateDatainCloud(params);
//     }
//   });
// };

//   const selectStudent = () => {
//     setAddStudentClicked(true)
//   }


//   const addStudentToTheBatch = () => {

//     console.log("meeting link used to find id ", meetEventId);

//     gapi.client.calendar.events.list({
//       calendarId: 'primary',
//     }).then(response => {
//       console.log("All events:", response.result.items);
//       const events = response.result.items;
//       const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//       if (matchingEvent) {
//         console.log("Matching event ID:", matchingEvent.id);
//         const matchingId = matchingEvent.id;


//         const updatedAttendees = newlyAddedStudentsToTheBatch.map((ele) => {
//           return { 'email': ele.email }
//         })
    
//         updatedAttendees.push({ 'email': mentorMailId })
    
//         console.log("the updatedAttendees are", updatedAttendees)
    
//         // Update the event with new attendees
//         gapi.client.calendar.events.patch({
//           calendarId: 'primary',
//           eventId: matchingId,
//           resource: {
//             attendees: updatedAttendees,
//           },
    
//         }).then(updatedResponse => {
//           console.log('Updated event:', updatedResponse.result);
//         }).catch(error => {
//           console.error('Error updating attendees:', error);
//         });
    
    
    
//         // You can now use matchingEvent.id as needed
//       } else {
//         console.log("No event found with the provided meet link.");
//       }
//     }).catch(error => {
//       console.error("Error fetching events:", error);
//     });

    

   
//     const newlyAddedStudentsToTheBatch = [...selectedRows]
//     console.log("tttttt", newlyAddedStudentsToTheBatch)

//     const newlyAddedStudents = newlyAddedStudentsToTheBatch.map((ele) => {
//       return ele.key
//     })

//     console.log("newly selected Students", newlyAddedStudents)
//     console.log("prestudent", preselectedStudents);

//     console.log(`the batch id is ${batchdetails.BatchId} the mentor id is ${batchdetails.mentorId} the mentor name is ${batchdetails.mentorName} the course id is ${batchdetails.courseId} the course name is ${batchdetails.courseName}`)
//     setPreSelectedStudents(newlyAddedStudents)
//     setAddedStudentToTheBatch(newlyAddedStudentsToTheBatch)
//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "batchProgress": batchdetails.batchProgress,
//       "StudentsEndrolled": newlyAddedStudentsToTheBatch,
//       "BatchId": batchdetails.BatchId,
//       "mentorId": batchdetails.mentorId,
//       "mentorName": batchdetails.mentorName,
//       "courseId": batchdetails.courseId,
//       "courseName": batchdetails.courseName,
//       "isStudentAdded": true
//     }
//     console.log("the params is", params)
//     updateDatainCloud(params)
//     console.log("newly students enrolled", newlyAddedStudentsToTheBatch)
//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedStudents));

//     setSelectedRows([])
//     setSearchValue("")
//     setFilteredData(studentDetails)
//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }


//   const cancelAddingStudentToTheBatch = () => {
//     const preselectedKeys = selectedRowKeys.filter((key) => preselectedStudents.includes(key));
//     console.log(preselectedKeys, "preselectedkeys")

//     const preselectedRecords = selectedRows.filter((row) => preselectedStudents.includes(row.key));

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedKeys));

//     // Reset the selected keys and rows to only include the preselected students
//     setSelectedRowKeys(preselectedKeys);
//     setSelectedRows(preselectedRecords);

//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }

//   const cancelEditChanges = () => {
//     setEditDate("")
//     setMeetLink("")
//     setStartDateTime("")
//     setEditMeetLink(false)
//   }
// const sweetAlertStyles = `
// .my-confirm-btn {
//   background-color: #FF7E84 !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
//   margin-right: 10px !important;
// }

// .my-cancel-btn {
//   background-color: #30BEAD !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
// }

// .my-confirm-btn:hover,
// .my-cancel-btn:hover {
//   opacity: 0.9;
// }

// .swal2-actions {
//   gap: 12px !important;
// }
// `;

//   return (
//     <>
//       <style>{sweetAlertStyles}</style>
//       <Header />
//       {loading ?
//         <div className="spinner" >
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={loading} />
//           </div></div> :
//         <div className="nav-tab-wrapper tabs  section-padding">
//           <div className="container">
//             <div className="grid grid-cols-12 gap-[30px]">
//               <div className="xl:col-span-4 lg:col-span-6 col-span-12 ">
//                 <div className="mini-title">Edit Your Batch</div>
//                 <div className="bg-white shadow-box7 p-4 rounded-md mt-8">
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Course Name : {batchdetails && batchdetails.courseName}
//                   </div>
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Date : {batchdetails && batchdetails.StartDate} {"   →   "}{batchdetails && batchdetails.EndDate}
//                     {/* ({batchdetails && batchdetails.Repeat}) */}
//                   </div>
//                   {/* <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Time : {batchdetails && batchdetails.StartTime} {"   →   "}{batchdetails && batchdetails.EndTime}
//                   </div> */}
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Mentor : {batchdetails && batchdetails.mentorName}
//                   </div>
//                   {/* {editbatchstatus ?
//                     <div className="pb-4 mt-4"> Status</div>
//                     : */}
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Batch Status : {batchdetails && batchdetails.batchProgress}
//                   </div>
//                   {!editmeetlink && !editbatchstatus ?
//                     <div>
//                       <div style={{ display: "flex" }}>
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditMeetLink(true)}>Edit Class</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "Scheduled" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Change Status</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Edit Batch Status</button> : ""}
//                         {!addStudentClicked && userType === "admin" && batchdetails &&
//                           (batchdetails.batchProgress === "Scheduled" || batchdetails.batchProgress === "InProgress") ? (
//                           <button className="btn btn-secondary mt-4 mr-4" onClick={selectStudent}>
//                             Add Student
//                           </button>
//                         ) : ""}


//                       </div>
//                       {userType === "admin" ? addStudentClicked && enableSubmitAddStudentButton ? <button className="btn btn-secondary mt-4 mr-4" onClick={addStudentToTheBatch}>Submit</button> : "" : ""}
//                       {userType === "admin" ? addStudentClicked ? <button className="btn btn-secondary mt-4 mr-4" onClick={cancelAddingStudentToTheBatch}>Cancel</button> : "" : ""}


//                     </div>
//                     : editmeetlink && !editbatchstatus ?
//                       <div>

//                         <select
//                           className="from-control focus:ring-0 mt-4 bg-[#ECECEC]"
//                           onChange={(e) => {
//                             console.log("tr", e.target.value)
//                             const indclass = e.target.value && batchdetails.ClassSchedule.filter(obj => obj.scheduleNumber === parseInt(e.target.value))[0]; setClassStatus(indclass ? indclass["status"] : ""); setMeetLink(indclass ? indclass["meet_link"] : ""); setStartDateTime(indclass ? indclass["startDateTime"] : ""); setSelectedClass(indclass); setEndDateTime(indclass ? indclass["endDateTime"] : ""); setEditDate(indclass ? indclass["startDateTime"] : "");
//                           }}
//                           required>
//                           <option key="" value="">Select Class</option>
//                           {batchdetails && batchdetails.ClassSchedule.map((item1, index) => (
//                             <option key={item1.scheduleNumber} value={item1.scheduleNumber}>{item1.startDateTime.split("T")[0]}</option>
//                           ))}
//                         </select>
//                         <input
//                           type="date"
//                           className="from-control mt-4"
//                           value={editDate ? editDate.split("T")[0] : ""}
//                           onChange={(e) =>
//                             setEditDate(e.target.value)}
//                         />
//                         <input
//                           type="text"
//                           className="from-control mt-4"
//                           value={meetlink}
//                           placeholder="Meet Link"
//                           onChange={(e) => setMeetLink(e.target.value)}
//                           required
//                           readOnly
//                         />
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={startDateTime ? startDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setStartDateTime(e.target.value)}
//                         />
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={endDateTime ? endDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setEndDateTime(e.target.value)}
//                         />
//                         <div className="input-container">


//                           <select
//                             className="from-control p-4 bg-[#ECECEC] text-[#827878] mt-4"
//                             value={classstatus}
//                             onChange={(e) => setClassStatus(e.target.value)}
//                             required
//                           >
//                             <option key="Scheduled" value="Scheduled">Scheduled</option>
//                             <option key="InProgress" value="InProgress">InProgress</option>
//                             <option key="Completed" value="Completed">Completed</option>
//                           </select>


//                         </div>
//                         {selectedClass ? "" : <button className="btn btn-black mt-4 mr-4" onClick={() => setEditMeetLink(false)}>Cancel</button>}

//                         {selectedClass ? selectedClass.meet_link !== meetlink ?
//                           <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                             <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.status !== classstatus ? <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                               <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.startDateTime.split("T")[0] === editDate ? "" : <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                                 <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : ""}
//                       </div> :
//                       !editmeetlink && editbatchstatus ?
//                         <div>
//                           <div className="input-container">
//                             <select
//                               className="from-control p-4 bg-[#ECECEC] text-[#827878] "
//                               value={status}
//                               onChange={(e) => setStatus(e.target.value)}
//                               required
//                             >
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="" value="">Scheduled</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="InProgress" value="InProgress">InProgress</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}

//                               {batchdetails.batchProgress === "InProgress" ? <option key="" value="">InProgress</option> : ""}
//                               {isCompletedVisible && (
//                                 <option key="Completed" value="Completed">Completed</option>
//                               )}
//                               {batchdetails.batchProgress === "InProgress" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}


//                             </select>


//                           </div>
//                           <button
//                             className=" btn btn-black mr-2 mt-2"
//                             onClick={() => setEditBatchStatus(false)}
//                           >
//                             Cancel
//                           </button>
//                           {status ? <button className="btn btn-black mt-4 mr-4" onClick={() => UpdateBatchProgress(status)}  >Save Changes</button> : ""}
//                         </div >
//                         :
//                         ""
//                   }

//                 </div>

//               </div>
//               <div className="xl:col-span-6 lg:col-span-6 col-span-12">
//                 {addStudentClicked ? <div className="bg-white shadow-box7 p-8 rounded-md">
//                   <Input
//                     placeholder="Search by Name or Phone number"
//                     className="from-control"
//                     value={searchValue}
//                     onChange={handleSearch}
//                     style={{ marginBottom: 16 }}

//                   />
//                   <Table
//                     rowSelection={enrolledrowSelection}
//                     className=""
//                     columns={columnss}
//                     dataSource={filteredData}
//                     pagination={filteredData.length > 9 ? true : false}
//                     rowKey={(record) => record.key}
//                   />
//                 </div>
//                   : <div className="bg-white shadow-box7 p-8 rounded-md">

//                     <Table
//                       className=""
//                       columns={columns}
//                       dataSource={batchdetails && batchdetails.StudentsEndrolled}
//                       pagination={batchdetails && batchdetails.StudentsEndrolled.length > 9 ? true : false}
//                       rowKey={(record) => record.key}
//                     />

//                   </div>}
//               </div>

//             </div>
//             <div className="bg-white shadow-box7 p-8 rounded-md mt-4">
//               <Table
//                 className=""
//                 columns={columnsClassSchedule}
//                 dataSource={batchdetails && batchdetails.ClassSchedule}
//                 pagination={batchdetails && batchdetails.ClassSchedule.length > 9 ? true : false}
//                 rowKey={(record) => record.scheduleNumber}
//               />
//             </div>
//           </div>
//         </div >}

//     </>
//   )

// }
// export default EditBatch;







































// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, json } from "react-router-dom"
// import Header from "../Header";
// import { Table, Input, Button, Popconfirm } from "antd";
// import { FetchBatchData, UpdateSingleClassOfBatch, updateBatchStatus, FetchMentorDetails } from "../../api/aws-api";
// import { ClassicSpinner, CombSpinner, MagicSpinner } from "react-spinners-kit";
// import Swal from 'sweetalert2'
// import { gapi } from 'gapi-script';
// import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";
// import { FetchStudentDetails } from "../../api/aws-api";



// const EditBatch = ({ meetLink }) => {
//   const [status, setStatus] = useState("")
//   const [classstatus, setClassStatus] = useState("")
//   const [loading, setLoading] = useState(false)
//   const [startDateTime, setStartDateTime] = useState()
//   const [endDateTime, setEndDateTime] = useState()
//   const [editDate, setEditDate] = useState()
//   const [signedIn, setSignedIn] = useState(false);
//   const [gmeetLink, setgMeetLink] = useState('');
//   const [calenderEvents, setCalenderEvents] = useState()
//   const [selectedClass, setSelectedClass] = useState()
//   const [editmeetlink, setEditMeetLink] = useState(false)
//   const [editbatchstatus, setEditBatchStatus] = useState(false)
//   const location = useLocation();
//   const [batchdetails, setBatchDetails] = useState()
//   const navigate = useNavigate()
//   const [userType, setUserType] = useState("")
//   const [addStudentClicked, setAddStudentClicked] = useState(false)
//   const [studentDetails, setStudentDetails] = useState([])
//   const [addedStudentsToTheBatch, setAddedStudentToTheBatch] = useState([])
//   const [isCompletedVisible, setIsCompletedVisible] = useState(false);

//   const [addedStudents, setAddedStudents] = useState([])

//   // Static per-mentor Google Meet link (replaces the old per-class link)
//   const [mentorMeetLink, setMentorMeetLink] = useState("");

//   const [selectedRowKeys, setSelectedRowKeys] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [searchValue, setSearchValue] = useState('');
//   const [filteredData, setFilteredData] = useState([]);
//   const [preselectedStudents, setPreSelectedStudents] = useState()
//   const [enableSubmitAddStudentButton, setEnableSubmitAddStudentButton] = useState(false)
//   const [studentsAlreadyInBatch, setStudentsAlreadyInBatch] = useState()
//   const [meetEventId, setMeetEventId] = useState("")
//   const [mentorMailId, setMentorMailId] = useState("")
//   const [matchingId, setMatchingId] = useState("");
//   const [studentsMail, setStudentsMail] = useState();


//   const CLIENT_ID = '347764156937-klkgu25nrg2l7pq8iticmrvha29f3vr7.apps.googleusercontent.com';
//   const API_KEY = 'AIzaSyCio8YcxXtf28_wN_ZWIHIjrlmzjGbXTJg';
//   const SCOPES = 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/admin.reports.audit.readonly';



//   useEffect(() => {

//     const { batch } = location.state ? location.state : []

//     const selectedBatchSession = sessionStorage.getItem("selectedBatch")

//     selectedBatchSession ? setBatchDetails(JSON.parse(selectedBatchSession)) : setBatchDetails(batch)

//     const extractedPart = batch.ClassSchedule[0].meet_link

//     console.log("the batch is", batch);
//     console.log("the batch in the editbatch  is", extractedPart)

//     const filteredBatch = batch
//     console.log("the batch in the editbatch  is", filteredBatch)
//     const mentorDetails = batch.mentorName;
//     console.log(mentorDetails, "mentor details");
//     setMeetEventId(extractedPart)
//     setMentorMailId('bharathmanojdev@gmail.com')
//     const type = JSON.parse(sessionStorage.getItem("UserData"))
//     setUserType(type.user_type)
//     fetchStudentDetails()
//     console.log("fgfdgfdgfdgdgfdgfd", batch.EventId)


//     const studentsAlreadyEnrolled = selectedBatchSession ? JSON.parse(selectedBatchSession).StudentsEndrolled.map((ele) => {
//       return ele.key
//     }) : batch.StudentsEndrolled.map((ele) => {
//       return ele.key
//     })

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//     console.log("batccjhh", studentsAlreadyEnrolled)
//     setPreSelectedStudents(studentsAlreadyEnrolled)
//     setSelectedRowKeys(studentsAlreadyEnrolled)

//     getBatchDatas()

//     // Look up this batch's mentor's static meet link, once, on load —
//     // not tied to any user action like removing a student.
//     fetchMentorMeetLink(batch.mentorId)

//   }, [])

//   useEffect(() => {
//     if (batchdetails && batchdetails.ClassSchedule) {
//       const allCompleted = batchdetails.ClassSchedule.every(
//         (item) => item.status === "Completed"
//       );
//       setIsCompletedVisible(allCompleted);
//     }
//   }, [batchdetails]);

//   useEffect(() => {
//     console.log("Updated students' emails:", studentsMail);
//   }, [studentsMail]);


//   const fetchMentorMeetLink = async (mentorId) => {
//     const mentors = await ConstructorEventGet(FetchMentorDetails);
//     const match = Array.isArray(mentors) ? mentors.find(m => m.user_id === mentorId) : null;
//     setMentorMeetLink(match ? match.meet_link : "");
//   };


//   const getBatchDatas = async () => {
//     const responsedata = await ConstructorEventGet(FetchBatchData, { "mentorId": "" })
//     console.log("the response data is ", responsedata
//     )


//     const removeCancelledBatches = responsedata.filter((ele) => {
//       return ele.batchProgress != "Cancelled"
//     })


//     const removeCompletedBatches = removeCancelledBatches.filter((ele) => {
//       return ele.batchProgress != "Completed"
//     })

//     console.log("the batches are", removeCompletedBatches)

//     const finalData = removeCompletedBatches.map((ele) => {
//       return ele.StudentsEndrolled.map((ele) => {
//         return ele.key
//       })
//     })

//     console.log("the final data is", finalData)

//     const studentsId = [...new Set(finalData.flat())]

//     setStudentsAlreadyInBatch(studentsId)
//     console.log("the students enrolled are", studentsId)

//   }

//   const fetchStudentDetails = async () => {
//     const responsedata = await ConstructorEventGet(FetchStudentDetails)
//     setStudentDetails(responsedata)
//     console.log("the rsponse data", responsedata)

//     const studentdata = responsedata.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     console.log("the student data is", studentdata)

//     setFilteredData(studentdata)
//     setStudentDetails(studentdata)
//   }


//   const removeStudentFromBatch = (studentKey) => {
//     console.log("the key will be", studentKey);
//     console.log("the batch details is", batchdetails);

//     if (!batchdetails) {
//       console.error("Batch details are not available");
//       return;
//     }

//     const deleteStudent = batchdetails.StudentsEndrolled.filter((ele) => {
//       return ele.key !== studentKey;
//     });

//     const updatedBatchDetails = {
//       ...batchdetails,
//       StudentsEndrolled: deleteStudent,
//     };

//     setBatchDetails(updatedBatchDetails);

//     const student = deleteStudent.map((ele) => ele.key);

//     setPreSelectedStudents(student);
//     setSelectedRowKeys(student);

//     const params = {
//       mentorId: batchdetails.mentorId,
//       BatchName: batchdetails.BatchName,
//       batchProgress: batchdetails.batchProgress,
//       StudentsEndrolled: deleteStudent,
//       BatchId: batchdetails.BatchId,
//       mentorName: batchdetails.mentorName,
//       courseId: batchdetails.courseId,
//       courseName: batchdetails.courseName,
//       isStudentRemoved: true,
//       studentId: studentKey,
//     };

//     updateDatainCloudForRemove(params);

//     setSelectedRows([]);
//     setSearchValue("");
//     setFilteredData(studentDetails);
//     setAddStudentClicked(false);
//     setEnableSubmitAddStudentButton(false);
//   };


//   const enrolledrowSelection = {
//     selectedRowKeys,
//     onChange: (selectedKeys, selectedRecords) => {

//       console.log("the selected keys are", selectedKeys)
//       const storedEnrolledStudents = JSON.parse(localStorage.getItem("studentsAlreadyEnrolled")) || [];
//       console.log("storedEnroled", storedEnrolledStudents);

//       const updatedSelectedKeys = Array.from(new Set([...storedEnrolledStudents, ...selectedKeys]));
//       setEnableSubmitAddStudentButton(true)
//       setSelectedRowKeys(updatedSelectedKeys);
//       console.log(updatedSelectedKeys, "selcted roew key 1");

//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(updatedSelectedKeys));

//       const updatedSelectedRecords = updatedSelectedKeys.map(key =>
//         studentDetails.find(student => student.key === key)
//       ).filter(record => record);

//       setSelectedRows(updatedSelectedRecords);
//       updatedSelectedRecords.forEach(row => {
//         console.log(`Selected Name: ${row.name}`);
//       });
//     },
//     getCheckboxProps: (record) => ({
//       disabled: studentsAlreadyInBatch.includes(record.key),
//     }),
//   };

//   const handleSearch = (e) => {
//     setSearchValue(e.target.value)

//     const userStudents = studentDetails.filter((ele) => {
//       return ele.user_type === "student"
//     })

//     const searchedValue = userStudents.filter((ele) => {
//       return ele.name.toLowerCase().includes(e.target.value.toLowerCase()) || ele.mobile.includes(e.target.value)
//     })
//     setFilteredData(searchedValue)
//   };

//   const columns = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Email",
//       dataIndex: "email",
//     },
//     {
//       title: "Phone",
//       dataIndex: "mobile",
//     },
//     ...(batchdetails && batchdetails.batchProgress !== "Completed"
//       ? [
//         {
//           title: 'Action',
//           key: 'action',
//           render: (_, record) => (
//             <Popconfirm
//               title="Are you sure you want to delete this student?"
//               onConfirm={() => removeStudentFromBatch(record.key)}
//               okButtonProps={{ className: 'popconfirm-ok-button' }}
//             >
//               <Button type="primary" style={{ backgroundColor: "red" }}>
//                 Remove
//               </Button>
//             </Popconfirm>
//           ),
//         },
//       ]
//       : [])
//   ];

//   const columnss = [
//     {
//       title: "Students",
//       dataIndex: "name",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//   ]

//   // Meet Link column removed — it's per-mentor now, shown once above the table
//   const columnsClassSchedule = [
//     {
//       title: "Class Id",
//       dataIndex: "scheduleNumber",
//       sorter: (a, b) => a.name.length - b.name.length,
//     },
//     {
//       title: "Start",
//       dataIndex: "startDateTime",
//     },
//     {
//       title: "End",
//       dataIndex: "endDateTime",
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//     }
//   ];

//   const savechanges = async () => {
//     console.log("start and enddate is", editDate)

//     const editDatee = editDate.split("T")[0]

//     console.log("startTime", startDateTime)
//     console.log("endTime", endDateTime)

//     const editedStartedDate = `${editDatee}T${startDateTime}:00`
//     const editedEndDate = `${editDatee}T${endDateTime}:00`

//     // meet_link no longer sent here — it's a mentor-level field now, not
//     // something set per class.
//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "scheduleNumber": selectedClass.scheduleNumber,
//       "status": classstatus,
//       "startDateTime": editedStartedDate,
//       "endDateTime": editedEndDate
//     }
//     setLoading(true)
//     const responsedata = await ConstructorEventPost(UpdateSingleClassOfBatch, params)
//     if (responsedata[0] === "updated") { setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setSelectedClass(""); setClassStatus(""); setEditDate(""); setStartDateTime(""); setEndDateTime(""); }
//     else { setLoading(false) }
//   }
//   const updateDatainCloud = async (params) => {

//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       console.log("the response data in adding batchstatus is", responsedata[1]);

//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1])); setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setStatus("")
//     }
//     else { setLoading(false) }

//   }
//   const updateDatainCloudForRemove = async (params) => {
//     setLoading(true)
//     const responsedata = await ConstructorEventPost(updateBatchStatus, params)
//     if (responsedata[0] === "updated") {
//       const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
//       localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));
//       sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1]));
//       setLoading(false);
//       setBatchDetails(responsedata[1]);
//       setEditBatchStatus(false);
//       setEditMeetLink(false);
//       setStatus("")

//       // Guard: gapi.client is never initialized on this page right now
//       // (the init block above is commented out), so this whole sync
//       // step is currently dead. Skip it instead of crashing.
//       if (gapi.client && gapi.client.calendar) {
//         const enrolledStudentsMail = batchdetails.StudentsEndrolled.map(student => ({
//           email: student.email,
//         }));

//         gapi.client.calendar.events.list({ calendarId: 'primary' })
//           .then(response => {
//             const matchingEvent = response.result.items.find(event => event.hangoutLink === meetEventId);
//             if (matchingEvent) {
//               gapi.client.calendar.events.patch({
//                 calendarId: 'primary',
//                 eventId: matchingEvent.id,
//                 resource: { attendees: enrolledStudentsMail },
//               }).catch(error => console.error('Error updating attendees:', error));
//             }
//           })
//           .catch(error => console.error("Error fetching events:", error));
//       } else {
//         console.warn("Skipping calendar attendee sync — Google API client not initialized on this page.");
//       }
//     } else {
//       setLoading(false)
//     }
//   }

//   const UpdateBatchProgress = (statusupdate) => {

//     const params = {
//       mentorId: batchdetails.mentorId,
//       BatchName: batchdetails.BatchName,
//       batchProgress: statusupdate,
//       StudentsEndrolled: batchdetails.StudentsEndrolled
//     };

//     Swal.fire({
//       title:
//         statusupdate === "Cancelled"
//           ? "Do you wish to cancel this batch?"
//           : statusupdate === "InProgress"
//           ? "Would you like to switch the status of this batch to In Progress?"
//           : statusupdate === "Completed"
//           ? "Would you like to switch the status of this batch to Completed?"
//           : "",

//       text:
//         statusupdate === "Cancelled"
//           ? `Cancel ${batchdetails.BatchName} ?`
//           : statusupdate === "InProgress"
//           ? `Start ${batchdetails.BatchName} ?`
//           : statusupdate === "Completed"
//           ? `Complete ${batchdetails.BatchName} ?`
//           : "",

//       icon:
//         statusupdate === "InProgress" || statusupdate === "Completed"
//           ? "success"
//           : "warning",

//       iconColor:
//         statusupdate === "InProgress" || statusupdate === "Completed"
//           ? "#4df766"
//           : "#fa414a",

//       showCancelButton: true,
//       confirmButtonText: "Yes, please",
//       cancelButtonText: "Nope, Changed my mind",

//       buttonsStyling: false,
//       customClass: {
//         confirmButton: "my-confirm-btn",
//         cancelButton: "my-cancel-btn"
//       }

//     }).then((result) => {
//       if (result.isConfirmed) {
//         updateDatainCloud(params);
//       }
//     });
//   };

//   const selectStudent = () => {
//     setAddStudentClicked(true)
//   }


//   const addStudentToTheBatch = () => {

//     console.log("meeting link used to find id ", meetEventId);

//     gapi.client.calendar.events.list({
//       calendarId: 'primary',
//     }).then(response => {
//       console.log("All events:", response.result.items);
//       const events = response.result.items;
//       const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

//       if (matchingEvent) {
//         console.log("Matching event ID:", matchingEvent.id);
//         const matchingId = matchingEvent.id;

//         const updatedAttendees = newlyAddedStudentsToTheBatch.map((ele) => {
//           return { 'email': ele.email }
//         })

//         updatedAttendees.push({ 'email': mentorMailId })

//         console.log("the updatedAttendees are", updatedAttendees)

//         gapi.client.calendar.events.patch({
//           calendarId: 'primary',
//           eventId: matchingId,
//           resource: {
//             attendees: updatedAttendees,
//           },

//         }).then(updatedResponse => {
//           console.log('Updated event:', updatedResponse.result);
//         }).catch(error => {
//           console.error('Error updating attendees:', error);
//         });

//       } else {
//         console.log("No event found with the provided meet link.");
//       }
//     }).catch(error => {
//       console.error("Error fetching events:", error);
//     });


//     const newlyAddedStudentsToTheBatch = [...selectedRows]
//     console.log("tttttt", newlyAddedStudentsToTheBatch)

//     const newlyAddedStudents = newlyAddedStudentsToTheBatch.map((ele) => {
//       return ele.key
//     })

//     console.log("newly selected Students", newlyAddedStudents)
//     console.log("prestudent", preselectedStudents);

//     console.log(`the batch id is ${batchdetails.BatchId} the mentor id is ${batchdetails.mentorId} the mentor name is ${batchdetails.mentorName} the course id is ${batchdetails.courseId} the course name is ${batchdetails.courseName}`)
//     setPreSelectedStudents(newlyAddedStudents)
//     setAddedStudentToTheBatch(newlyAddedStudentsToTheBatch)
//     const params = {
//       "mentorId": batchdetails.mentorId,
//       "BatchName": batchdetails.BatchName,
//       "batchProgress": batchdetails.batchProgress,
//       "StudentsEndrolled": newlyAddedStudentsToTheBatch,
//       "BatchId": batchdetails.BatchId,
//       "mentorName": batchdetails.mentorName,
//       "courseId": batchdetails.courseId,
//       "courseName": batchdetails.courseName,
//       "isStudentAdded": true
//     }
//     console.log("the params is", params)
//     updateDatainCloud(params)
//     console.log("newly students enrolled", newlyAddedStudentsToTheBatch)
//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedStudents));

//     setSelectedRows([])
//     setSearchValue("")
//     setFilteredData(studentDetails)
//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }


//   const cancelAddingStudentToTheBatch = () => {
//     const preselectedKeys = selectedRowKeys.filter((key) => preselectedStudents.includes(key));
//     console.log(preselectedKeys, "preselectedkeys")

//     const preselectedRecords = selectedRows.filter((row) => preselectedStudents.includes(row.key));

//     localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedKeys));

//     setSelectedRowKeys(preselectedKeys);
//     setSelectedRows(preselectedRecords);

//     setAddStudentClicked(false)
//     setEnableSubmitAddStudentButton(false)
//   }

//   const cancelEditChanges = () => {
//     setEditDate("")
//     setStartDateTime("")
//     setEditMeetLink(false)
//   }

//   const sweetAlertStyles = `
// .my-confirm-btn {
//   background-color: #FF7E84 !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
//   margin-right: 10px !important;
// }

// .my-cancel-btn {
//   background-color: #30BEAD !important;
//   color: #ffffff !important;
//   padding: 10px 22px !important;
//   border-radius: 6px !important;
//   border: none !important;
//   font-weight: 600 !important;
// }

// .my-confirm-btn:hover,
// .my-cancel-btn:hover {
//   opacity: 0.9;
// }

// .swal2-actions {
//   gap: 12px !important;
// }
// `;

//   return (
//     <>
//       <style>{sweetAlertStyles}</style>
//       <Header />
//       {loading ?
//         <div className="spinner" >
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={loading} />
//           </div></div> :
//         <div className="nav-tab-wrapper tabs  section-padding">
//           <div className="container">
//             <div className="grid grid-cols-12 gap-[30px]">
//               <div className="xl:col-span-4 lg:col-span-6 col-span-12 ">
//                 <div className="mini-title">Edit Your Batch</div>
//                 <div className="bg-white shadow-box7 p-4 rounded-md mt-8">
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Course Name : {batchdetails && batchdetails.courseName}
//                   </div>
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Date : {batchdetails && batchdetails.StartDate} {"   →   "}{batchdetails && batchdetails.EndDate}
//                   </div>
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Mentor : {batchdetails && batchdetails.mentorName}
//                   </div>

//                   {/* Static, mentor-level meet link — replaces the old per-class field */}
//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Meet Link :{" "}
//                     {mentorMeetLink
//                       ? <a href={mentorMeetLink} target="_blank" rel="noopener noreferrer">{mentorMeetLink}</a>
//                       : "Not set for this mentor"}
//                   </div>

//                   <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
//                     Batch Status : {batchdetails && batchdetails.batchProgress}
//                   </div>
//                   {!editmeetlink && !editbatchstatus ?
//                     <div>
//                       <div style={{ display: "flex" }}>
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditMeetLink(true)}>Edit Class</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "Scheduled" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Change Status</button> : ""}
//                         {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Edit Batch Status</button> : ""}
//                         {!addStudentClicked && userType === "admin" && batchdetails &&
//                           (batchdetails.batchProgress === "Scheduled" || batchdetails.batchProgress === "InProgress") ? (
//                           <button className="btn btn-secondary mt-4 mr-4" onClick={selectStudent}>
//                             Add Student
//                           </button>
//                         ) : ""}


//                       </div>
//                       {userType === "admin" ? addStudentClicked && enableSubmitAddStudentButton ? <button className="btn btn-secondary mt-4 mr-4" onClick={addStudentToTheBatch}>Submit</button> : "" : ""}
//                       {userType === "admin" ? addStudentClicked ? <button className="btn btn-secondary mt-4 mr-4" onClick={cancelAddingStudentToTheBatch}>Cancel</button> : "" : ""}


//                     </div>
//                     : editmeetlink && !editbatchstatus ?
//                       <div>

//                         <select
//                           className="from-control focus:ring-0 mt-4 bg-[#ECECEC]"
//                           onChange={(e) => {
//                             console.log("tr", e.target.value)
//                             const indclass = e.target.value && batchdetails.ClassSchedule.filter(obj => obj.scheduleNumber === parseInt(e.target.value))[0];
//                             setClassStatus(indclass ? indclass["status"] : "");
//                             setStartDateTime(indclass ? indclass["startDateTime"] : "");
//                             setSelectedClass(indclass);
//                             setEndDateTime(indclass ? indclass["endDateTime"] : "");
//                             setEditDate(indclass ? indclass["startDateTime"] : "");
//                           }}
//                           required>
//                           <option key="" value="">Select Class</option>
//                           {batchdetails && batchdetails.ClassSchedule.map((item1, index) => (
//                             <option key={item1.scheduleNumber} value={item1.scheduleNumber}>{item1.startDateTime.split("T")[0]}</option>
//                           ))}
//                         </select>
//                         <input
//                           type="date"
//                           className="from-control mt-4"
//                           value={editDate ? editDate.split("T")[0] : ""}
//                           onChange={(e) =>
//                             setEditDate(e.target.value)}
//                         />
//                         {/* Meet Link input removed — link is per-mentor now, shown read-only above */}
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={startDateTime ? startDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setStartDateTime(e.target.value)}
//                         />
//                         <input
//                           type="time"
//                           className="from-control mt-4"
//                           value={endDateTime ? endDateTime.split("T")[1] : ""}
//                           onChange={(e) =>
//                             setEndDateTime(e.target.value)}
//                         />
//                         <div className="input-container">
//                           <select
//                             className="from-control p-4 bg-[#ECECEC] text-[#827878] mt-4"
//                             value={classstatus}
//                             onChange={(e) => setClassStatus(e.target.value)}
//                             required
//                           >
//                             <option key="Scheduled" value="Scheduled">Scheduled</option>
//                             <option key="InProgress" value="InProgress">InProgress</option>
//                             <option key="Completed" value="Completed">Completed</option>
//                           </select>
//                         </div>
//                         {selectedClass ? "" : <button className="btn btn-black mt-4 mr-4" onClick={() => setEditMeetLink(false)}>Cancel</button>}

//                         {selectedClass ? selectedClass.status !== classstatus ?
//                           <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                             <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.startDateTime.split("T")[0] === editDate ? "" : <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
//                               <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : ""}
//                       </div> :
//                       !editmeetlink && editbatchstatus ?
//                         <div>
//                           <div className="input-container">
//                             <select
//                               className="from-control p-4 bg-[#ECECEC] text-[#827878] "
//                               value={status}
//                               onChange={(e) => setStatus(e.target.value)}
//                               required
//                             >
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="" value="">Scheduled</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="InProgress" value="InProgress">InProgress</option> : ""}
//                               {batchdetails.batchProgress === "Scheduled" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}

//                               {batchdetails.batchProgress === "InProgress" ? <option key="" value="">InProgress</option> : ""}
//                               {isCompletedVisible && (
//                                 <option key="Completed" value="Completed">Completed</option>
//                               )}
//                               {batchdetails.batchProgress === "InProgress" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}


//                             </select>


//                           </div>
//                           <button
//                             className=" btn btn-black mr-2 mt-2"
//                             onClick={() => setEditBatchStatus(false)}
//                           >
//                             Cancel
//                           </button>
//                           {status ? <button className="btn btn-black mt-4 mr-4" onClick={() => UpdateBatchProgress(status)}  >Save Changes</button> : ""}
//                         </div >
//                         :
//                         ""
//                   }

//                 </div>

//               </div>
//               <div className="xl:col-span-6 lg:col-span-6 col-span-12">
//                 {addStudentClicked ? <div className="bg-white shadow-box7 p-8 rounded-md">
//                   <Input
//                     placeholder="Search by Name or Phone number"
//                     className="from-control"
//                     value={searchValue}
//                     onChange={handleSearch}
//                     style={{ marginBottom: 16 }}

//                   />
//                   <Table
//                     rowSelection={enrolledrowSelection}
//                     className=""
//                     columns={columnss}
//                     dataSource={filteredData}
//                     pagination={filteredData.length > 9 ? true : false}
//                     rowKey={(record) => record.key}
//                   />
//                 </div>
//                   : <div className="bg-white shadow-box7 p-8 rounded-md">

//                     <Table
//                       className=""
//                       columns={columns}
//                       dataSource={batchdetails && batchdetails.StudentsEndrolled}
//                       pagination={batchdetails && batchdetails.StudentsEndrolled.length > 9 ? true : false}
//                       rowKey={(record) => record.key}
//                     />

//                   </div>}
//               </div>

//             </div>
//             <div className="bg-white shadow-box7 p-8 rounded-md mt-4">
//               <Table
//                 className=""
//                 columns={columnsClassSchedule}
//                 dataSource={batchdetails && batchdetails.ClassSchedule}
//                 pagination={batchdetails && batchdetails.ClassSchedule.length > 9 ? true : false}
//                 rowKey={(record) => record.scheduleNumber}
//               />
//             </div>
//           </div>
//         </div >}

//     </>
//   )

// }
// export default EditBatch;














































import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, json } from "react-router-dom"
import Header from "../Header";
import { Table, Input, Button, Popconfirm } from "antd";
import { FetchBatchData, UpdateSingleClassOfBatch, updateBatchStatus, FetchMentorDetails } from "../../api/aws-api";
import { ClassicSpinner, CombSpinner, MagicSpinner } from "react-spinners-kit";
import Swal from 'sweetalert2'
import { gapi } from 'gapi-script';
import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";
import { FetchStudentDetails } from "../../api/aws-api";
// CHANGED: toast helpers used by the class update flow
import { notifySuccess, notifyError } from "../../Common/CommonFunction";



const EditBatch = ({ meetLink }) => {
  const [status, setStatus] = useState("")
  const [classstatus, setClassStatus] = useState("")
  const [loading, setLoading] = useState(false)
  const [startDateTime, setStartDateTime] = useState()
  const [endDateTime, setEndDateTime] = useState()
  const [editDate, setEditDate] = useState()
  const [signedIn, setSignedIn] = useState(false);
  const [gmeetLink, setgMeetLink] = useState('');
  const [calenderEvents, setCalenderEvents] = useState()
  const [selectedClass, setSelectedClass] = useState()
  const [editmeetlink, setEditMeetLink] = useState(false)
  const [editbatchstatus, setEditBatchStatus] = useState(false)
  const location = useLocation();
  const [batchdetails, setBatchDetails] = useState()
  const navigate = useNavigate()
  const [userType, setUserType] = useState("")
  const [addStudentClicked, setAddStudentClicked] = useState(false)
  const [studentDetails, setStudentDetails] = useState([])
  const [addedStudentsToTheBatch, setAddedStudentToTheBatch] = useState([])
  const [isCompletedVisible, setIsCompletedVisible] = useState(false);

  const [addedStudents, setAddedStudents] = useState([])

  // Static per-mentor Google Meet link (replaces the old per-class link)
  const [mentorMeetLink, setMentorMeetLink] = useState("");

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [preselectedStudents, setPreSelectedStudents] = useState()
  const [enableSubmitAddStudentButton, setEnableSubmitAddStudentButton] = useState(false)
  const [studentsAlreadyInBatch, setStudentsAlreadyInBatch] = useState()
  const [meetEventId, setMeetEventId] = useState("")
  const [mentorMailId, setMentorMailId] = useState("")
  const [matchingId, setMatchingId] = useState("");
  const [studentsMail, setStudentsMail] = useState();


  const CLIENT_ID = '347764156937-klkgu25nrg2l7pq8iticmrvha29f3vr7.apps.googleusercontent.com';
  const API_KEY = 'AIzaSyCio8YcxXtf28_wN_ZWIHIjrlmzjGbXTJg';
  const SCOPES = 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/admin.reports.audit.readonly';



  useEffect(() => {

    const { batch } = location.state ? location.state : []

    const selectedBatchSession = sessionStorage.getItem("selectedBatch")

    selectedBatchSession ? setBatchDetails(JSON.parse(selectedBatchSession)) : setBatchDetails(batch)

    const extractedPart = batch.ClassSchedule[0].meet_link

    console.log("the batch is", batch);
    console.log("the batch in the editbatch  is", extractedPart)

    const filteredBatch = batch
    console.log("the batch in the editbatch  is", filteredBatch)
    const mentorDetails = batch.mentorName;
    console.log(mentorDetails, "mentor details");
    setMeetEventId(extractedPart)
    setMentorMailId('bharathmanojdev@gmail.com')
    const type = JSON.parse(sessionStorage.getItem("UserData"))
    setUserType(type.user_type)
    fetchStudentDetails()
    console.log("fgfdgfdgfdgdgfdgfd", batch.EventId)


    const studentsAlreadyEnrolled = selectedBatchSession ? JSON.parse(selectedBatchSession).StudentsEndrolled.map((ele) => {
      return ele.key
    }) : batch.StudentsEndrolled.map((ele) => {
      return ele.key
    })

    localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

    console.log("batccjhh", studentsAlreadyEnrolled)
    setPreSelectedStudents(studentsAlreadyEnrolled)
    setSelectedRowKeys(studentsAlreadyEnrolled)

    getBatchDatas()

    // Look up this batch's mentor's static meet link, once, on load —
    // not tied to any user action like removing a student.
    fetchMentorMeetLink(batch.mentorId)

  }, [])

  useEffect(() => {
    if (batchdetails && batchdetails.ClassSchedule) {
      const allCompleted = batchdetails.ClassSchedule.every(
        (item) => item.status === "Completed"
      );
      setIsCompletedVisible(allCompleted);
    }
  }, [batchdetails]);

  useEffect(() => {
    console.log("Updated students' emails:", studentsMail);
  }, [studentsMail]);


  const fetchMentorMeetLink = async (mentorId) => {
    const mentors = await ConstructorEventGet(FetchMentorDetails);
    const match = Array.isArray(mentors) ? mentors.find(m => m.user_id === mentorId) : null;
    setMentorMeetLink(match ? match.meet_link : "");
  };


  const getBatchDatas = async () => {
    const responsedata = await ConstructorEventGet(FetchBatchData, { "mentorId": "" })
    console.log("the response data is ", responsedata
    )


    const removeCancelledBatches = responsedata.filter((ele) => {
      return ele.batchProgress != "Cancelled"
    })


    const removeCompletedBatches = removeCancelledBatches.filter((ele) => {
      return ele.batchProgress != "Completed"
    })

    console.log("the batches are", removeCompletedBatches)

    const finalData = removeCompletedBatches.map((ele) => {
      return ele.StudentsEndrolled.map((ele) => {
        return ele.key
      })
    })

    console.log("the final data is", finalData)

    const studentsId = [...new Set(finalData.flat())]

    setStudentsAlreadyInBatch(studentsId)
    console.log("the students enrolled are", studentsId)

  }

  const fetchStudentDetails = async () => {
    const responsedata = await ConstructorEventGet(FetchStudentDetails)
    setStudentDetails(responsedata)
    console.log("the rsponse data", responsedata)

    const studentdata = responsedata.filter((ele) => {
      return ele.user_type === "student"
    })

    console.log("the student data is", studentdata)

    setFilteredData(studentdata)
    setStudentDetails(studentdata)
  }


  const removeStudentFromBatch = (studentKey) => {
    console.log("the key will be", studentKey);
    console.log("the batch details is", batchdetails);

    if (!batchdetails) {
      console.error("Batch details are not available");
      return;
    }

    const deleteStudent = batchdetails.StudentsEndrolled.filter((ele) => {
      return ele.key !== studentKey;
    });

    const updatedBatchDetails = {
      ...batchdetails,
      StudentsEndrolled: deleteStudent,
    };

    setBatchDetails(updatedBatchDetails);

    const student = deleteStudent.map((ele) => ele.key);

    setPreSelectedStudents(student);
    setSelectedRowKeys(student);

    const params = {
      mentorId: batchdetails.mentorId,
      BatchName: batchdetails.BatchName,
      batchProgress: batchdetails.batchProgress,
      StudentsEndrolled: deleteStudent,
      BatchId: batchdetails.BatchId,
      mentorName: batchdetails.mentorName,
      courseId: batchdetails.courseId,
      courseName: batchdetails.courseName,
      isStudentRemoved: true,
      studentId: studentKey,
    };

    updateDatainCloudForRemove(params);

    setSelectedRows([]);
    setSearchValue("");
    setFilteredData(studentDetails);
    setAddStudentClicked(false);
    setEnableSubmitAddStudentButton(false);
  };


  const enrolledrowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys, selectedRecords) => {

      console.log("the selected keys are", selectedKeys)
      const storedEnrolledStudents = JSON.parse(localStorage.getItem("studentsAlreadyEnrolled")) || [];
      console.log("storedEnroled", storedEnrolledStudents);

      const updatedSelectedKeys = Array.from(new Set([...storedEnrolledStudents, ...selectedKeys]));
      setEnableSubmitAddStudentButton(true)
      setSelectedRowKeys(updatedSelectedKeys);
      console.log(updatedSelectedKeys, "selcted roew key 1");

      localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(updatedSelectedKeys));

      const updatedSelectedRecords = updatedSelectedKeys.map(key =>
        studentDetails.find(student => student.key === key)
      ).filter(record => record);

      setSelectedRows(updatedSelectedRecords);
      updatedSelectedRecords.forEach(row => {
        console.log(`Selected Name: ${row.name}`);
      });
    },
    getCheckboxProps: (record) => ({
      disabled: studentsAlreadyInBatch.includes(record.key),
    }),
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value)

    const userStudents = studentDetails.filter((ele) => {
      return ele.user_type === "student"
    })

    const searchedValue = userStudents.filter((ele) => {
      return ele.name.toLowerCase().includes(e.target.value.toLowerCase()) || ele.mobile.includes(e.target.value)
    })
    setFilteredData(searchedValue)
  };

  const columns = [
    {
      title: "Students",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobile",
    },
    ...(batchdetails && batchdetails.batchProgress !== "Completed"
      ? [
        {
          title: 'Action',
          key: 'action',
          render: (_, record) => (
            <Popconfirm
              title="Are you sure you want to delete this student?"
              onConfirm={() => removeStudentFromBatch(record.key)}
              okButtonProps={{ className: 'popconfirm-ok-button' }}
            >
              <Button type="primary" style={{ backgroundColor: "red" }}>
                Remove
              </Button>
            </Popconfirm>
          ),
        },
      ]
      : [])
  ];

  const columnss = [
    {
      title: "Students",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
  ]

  // ================= CLASS CANCEL / RESCHEDULE (NEW) =================

  // Asks for a new date/time when a class is cancelled.
  // Returns null if the admin backs out, { value: null } to cancel without
  // rescheduling, or { value: { startDateTime, endDateTime } } to reschedule.
  const askReschedule = async (cls) => {
    const startDefault = (cls.startDateTime || "").slice(11, 16);
    const endDefault = (cls.endDateTime || "").slice(11, 16);

    const result = await Swal.fire({
      title: `Class ${cls.scheduleNumber} cancelled`,
      html: `
        <p>Pick a new date and time to reschedule it.</p>
        <input id="rs-date" type="date" class="swal2-input">
        <input id="rs-start" type="time" class="swal2-input" value="${startDefault}">
        <input id="rs-end" type="time" class="swal2-input" value="${endDefault}">`,
      // Some global stylesheet in the project strips SweetAlert2's default
      // button colors (they only showed on hover), so these buttons use
      // their own classes, styled in sweetAlertStyles below.
      buttonsStyling: false,
      customClass: {
        confirmButton: "rs-confirm-btn",
        denyButton: "rs-deny-btn",
        cancelButton: "rs-back-btn",
      },
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Reschedule",
      denyButtonText: "Cancel without rescheduling",
      cancelButtonText: "Back",
      preConfirm: () => {
        const date = document.getElementById("rs-date").value;
        const start = document.getElementById("rs-start").value;
        const end = document.getElementById("rs-end").value;
        if (!date || !start || !end) {
          Swal.showValidationMessage("Enter the date, start time and end time");
          return false;
        }
        if (end <= start) {
          Swal.showValidationMessage("End time must be after start time");
          return false;
        }
        return { startDateTime: `${date}T${start}:00`, endDateTime: `${date}T${end}:00` };
      },
    });

    if (result.isConfirmed) return { value: result.value };
    if (result.isDenied) return { value: null };
    return null;
  };

  // Sends one class update to the UpdateSingleClassOfBatch lambda and
  // refreshes the page from what the lambda returns.
  const postClassUpdate = async (params) => {
    setLoading(true);
    const responsedata = await ConstructorEventPost(UpdateSingleClassOfBatch, params);
    if (responsedata && responsedata[0] === "updated") {
      setBatchDetails(responsedata[1]);
      setEditBatchStatus(false);
      setEditMeetLink(false);
      setSelectedClass("");
      setClassStatus("");
      setEditDate("");
      setStartDateTime("");
      setEndDateTime("");
      notifySuccess(params.reschedule ? "Class cancelled and rescheduled" : "Class updated");
    } else {
      notifyError((responsedata && responsedata.error) || "Failed to update class");
    }
    setLoading(false);
  };

  // Used by the "Edit Class" panel on the left
  const savechanges = async () => {
    const editDatee = editDate.split("T")[0];

    // meet_link is not sent — it's a mentor-level field now.
    const params = {
      mentorId: batchdetails.mentorId,
      BatchName: batchdetails.BatchName,
      scheduleNumber: selectedClass.scheduleNumber,
      status: classstatus,
      startDateTime: `${editDatee}T${startDateTime}:00`,
      endDateTime: `${editDatee}T${endDateTime}:00`,
    };

    if (classstatus === "Cancelled") {
      const ask = await askReschedule(selectedClass);
      if (!ask) return;
      params.reschedule = ask.value;
    }

    await postClassUpdate(params);
  };

  // Used by the Status dropdown inside the class table
  const changeClassStatus = async (record, newStatus) => {
    const params = {
      mentorId: batchdetails.mentorId,
      BatchName: batchdetails.BatchName,
      scheduleNumber: record.scheduleNumber,
      status: newStatus,
      startDateTime: record.startDateTime,
      endDateTime: record.endDateTime,
    };

    if (newStatus === "Cancelled") {
      const ask = await askReschedule(record);
      if (!ask) return;
      params.reschedule = ask.value;
    }

    await postClassUpdate(params);
  };

  // Meet Link column removed — it's per-mentor now, shown once above the table
  const columnsClassSchedule = [
    {
      title: "Class Id",
      dataIndex: "scheduleNumber",
      // CHANGED: was a.name.length, which crashes (class rows have no name)
      sorter: (a, b) => a.scheduleNumber - b.scheduleNumber,
    },
    {
      title: "Start",
      dataIndex: "startDateTime",
    },
    {
      title: "End",
      dataIndex: "endDateTime",
    },
    {
      title: "Status",
      dataIndex: "status",
      // CHANGED: editable dropdown while the batch is InProgress.
      // Cancelled classes are read-only.
      render: (value, record) => {
        const editable =
          batchdetails &&
          batchdetails.batchProgress === "InProgress" &&
          value !== "Cancelled";
        if (!editable) return value;
        return (
          <select
            value={value}
            onChange={(e) => changeClassStatus(record, e.target.value)}
          >
            {["Scheduled", "InProgress", "Completed", "Cancelled"].map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        );
      },
    }
  ];

  const updateDatainCloud = async (params) => {

    setLoading(true)
    const responsedata = await ConstructorEventPost(updateBatchStatus, params)
    if (responsedata[0] === "updated") {
      console.log("the response data in adding batchstatus is", responsedata[1]);

      const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
      localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));

      sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1])); setLoading(false); setBatchDetails(responsedata[1]); setEditBatchStatus(false); setEditMeetLink(false); setStatus("")
    }
    else { setLoading(false) }

  }
  const updateDatainCloudForRemove = async (params) => {
    setLoading(true)
    const responsedata = await ConstructorEventPost(updateBatchStatus, params)
    if (responsedata[0] === "updated") {
      const studentsAlreadyEnrolled = responsedata[1].StudentsEndrolled.map(student => student.key);
      localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(studentsAlreadyEnrolled));
      sessionStorage.setItem("selectedBatch", JSON.stringify(responsedata[1]));
      setLoading(false);
      setBatchDetails(responsedata[1]);
      setEditBatchStatus(false);
      setEditMeetLink(false);
      setStatus("")

      // Guard: gapi.client is never initialized on this page right now
      // (the init block above is commented out), so this whole sync
      // step is currently dead. Skip it instead of crashing.
      if (gapi.client && gapi.client.calendar) {
        const enrolledStudentsMail = batchdetails.StudentsEndrolled.map(student => ({
          email: student.email,
        }));

        gapi.client.calendar.events.list({ calendarId: 'primary' })
          .then(response => {
            const matchingEvent = response.result.items.find(event => event.hangoutLink === meetEventId);
            if (matchingEvent) {
              gapi.client.calendar.events.patch({
                calendarId: 'primary',
                eventId: matchingEvent.id,
                resource: { attendees: enrolledStudentsMail },
              }).catch(error => console.error('Error updating attendees:', error));
            }
          })
          .catch(error => console.error("Error fetching events:", error));
      } else {
        console.warn("Skipping calendar attendee sync — Google API client not initialized on this page.");
      }
    } else {
      setLoading(false)
    }
  }

  const UpdateBatchProgress = (statusupdate) => {

    const params = {
      mentorId: batchdetails.mentorId,
      BatchName: batchdetails.BatchName,
      batchProgress: statusupdate,
      StudentsEndrolled: batchdetails.StudentsEndrolled
    };

    Swal.fire({
      title:
        statusupdate === "Cancelled"
          ? "Do you wish to cancel this batch?"
          : statusupdate === "InProgress"
          ? "Would you like to switch the status of this batch to In Progress?"
          : statusupdate === "Completed"
          ? "Would you like to switch the status of this batch to Completed?"
          : "",

      text:
        statusupdate === "Cancelled"
          ? `Cancel ${batchdetails.BatchName} ?`
          : statusupdate === "InProgress"
          ? `Start ${batchdetails.BatchName} ?`
          : statusupdate === "Completed"
          ? `Complete ${batchdetails.BatchName} ?`
          : "",

      icon:
        statusupdate === "InProgress" || statusupdate === "Completed"
          ? "success"
          : "warning",

      iconColor:
        statusupdate === "InProgress" || statusupdate === "Completed"
          ? "#4df766"
          : "#fa414a",

      showCancelButton: true,
      confirmButtonText: "Yes, please",
      cancelButtonText: "Nope, Changed my mind",

      buttonsStyling: false,
      customClass: {
        confirmButton: "my-confirm-btn",
        cancelButton: "my-cancel-btn"
      }

    }).then((result) => {
      if (result.isConfirmed) {
        updateDatainCloud(params);
      }
    });
  };

  const selectStudent = () => {
    setAddStudentClicked(true)
  }


  const addStudentToTheBatch = () => {

    console.log("meeting link used to find id ", meetEventId);

    gapi.client.calendar.events.list({
      calendarId: 'primary',
    }).then(response => {
      console.log("All events:", response.result.items);
      const events = response.result.items;
      const matchingEvent = events.find(event => event.hangoutLink === meetEventId);

      if (matchingEvent) {
        console.log("Matching event ID:", matchingEvent.id);
        const matchingId = matchingEvent.id;

        const updatedAttendees = newlyAddedStudentsToTheBatch.map((ele) => {
          return { 'email': ele.email }
        })

        updatedAttendees.push({ 'email': mentorMailId })

        console.log("the updatedAttendees are", updatedAttendees)

        gapi.client.calendar.events.patch({
          calendarId: 'primary',
          eventId: matchingId,
          resource: {
            attendees: updatedAttendees,
          },

        }).then(updatedResponse => {
          console.log('Updated event:', updatedResponse.result);
        }).catch(error => {
          console.error('Error updating attendees:', error);
        });

      } else {
        console.log("No event found with the provided meet link.");
      }
    }).catch(error => {
      console.error("Error fetching events:", error);
    });


    const newlyAddedStudentsToTheBatch = [...selectedRows]
    console.log("tttttt", newlyAddedStudentsToTheBatch)

    const newlyAddedStudents = newlyAddedStudentsToTheBatch.map((ele) => {
      return ele.key
    })

    console.log("newly selected Students", newlyAddedStudents)
    console.log("prestudent", preselectedStudents);

    console.log(`the batch id is ${batchdetails.BatchId} the mentor id is ${batchdetails.mentorId} the mentor name is ${batchdetails.mentorName} the course id is ${batchdetails.courseId} the course name is ${batchdetails.courseName}`)
    setPreSelectedStudents(newlyAddedStudents)
    setAddedStudentToTheBatch(newlyAddedStudentsToTheBatch)
    const params = {
      "mentorId": batchdetails.mentorId,
      "BatchName": batchdetails.BatchName,
      "batchProgress": batchdetails.batchProgress,
      "StudentsEndrolled": newlyAddedStudentsToTheBatch,
      "BatchId": batchdetails.BatchId,
      "mentorName": batchdetails.mentorName,
      "courseId": batchdetails.courseId,
      "courseName": batchdetails.courseName,
      "isStudentAdded": true
    }
    console.log("the params is", params)
    updateDatainCloud(params)
    console.log("newly students enrolled", newlyAddedStudentsToTheBatch)
    localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedStudents));

    setSelectedRows([])
    setSearchValue("")
    setFilteredData(studentDetails)
    setAddStudentClicked(false)
    setEnableSubmitAddStudentButton(false)
  }


  const cancelAddingStudentToTheBatch = () => {
    const preselectedKeys = selectedRowKeys.filter((key) => preselectedStudents.includes(key));
    console.log(preselectedKeys, "preselectedkeys")

    const preselectedRecords = selectedRows.filter((row) => preselectedStudents.includes(row.key));

    localStorage.setItem("studentsAlreadyEnrolled", JSON.stringify(preselectedKeys));

    setSelectedRowKeys(preselectedKeys);
    setSelectedRows(preselectedRecords);

    setAddStudentClicked(false)
    setEnableSubmitAddStudentButton(false)
  }

  const cancelEditChanges = () => {
    setEditDate("")
    setStartDateTime("")
    setEditMeetLink(false)
  }

  const sweetAlertStyles = `
.my-confirm-btn {
  background-color: #FF7E84 !important;
  color: #ffffff !important;
  padding: 10px 22px !important;
  border-radius: 6px !important;
  border: none !important;
  font-weight: 600 !important;
  margin-right: 10px !important;
}

.my-cancel-btn {
  background-color: #30BEAD !important;
  color: #ffffff !important;
  padding: 10px 22px !important;
  border-radius: 6px !important;
  border: none !important;
  font-weight: 600 !important;
}

.my-confirm-btn:hover,
.my-cancel-btn:hover {
  opacity: 0.9;
}

.rs-confirm-btn,
.rs-deny-btn,
.rs-back-btn {
  color: #ffffff !important;
  padding: 10px 22px !important;
  border-radius: 6px !important;
  border: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  cursor: pointer !important;
  opacity: 1 !important;
}

.rs-confirm-btn { background-color: #000000 !important; }
.rs-deny-btn { background-color: #dc2626 !important; }
.rs-back-btn { background-color: #6b7280 !important; }

.rs-confirm-btn:hover,
.rs-deny-btn:hover,
.rs-back-btn:hover {
  opacity: 0.9 !important;
}

.swal2-actions {
  gap: 12px !important;
}
`;

  return (
    <>
      <style>{sweetAlertStyles}</style>
      <Header />
      {loading ?
        <div className="spinner" >
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={loading} />
          </div></div> :
        <div className="nav-tab-wrapper tabs  section-padding">
          <div className="container">
            <div className="grid grid-cols-12 gap-[30px]">
              <div className="xl:col-span-4 lg:col-span-6 col-span-12 ">
                <div className="mini-title">Edit Your Batch</div>
                <div className="bg-white shadow-box7 p-4 rounded-md mt-8">
                  <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
                    Course Name : {batchdetails && batchdetails.courseName}
                  </div>
                  <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
                    Date : {batchdetails && batchdetails.StartDate} {"   →   "}{batchdetails && batchdetails.EndDate}
                  </div>
                  <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
                    Mentor : {batchdetails && batchdetails.mentorName}
                  </div>

                  {/* Static, mentor-level meet link — replaces the old per-class field */}
                  <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
                    Meet Link :{" "}
                    {mentorMeetLink
                      ? <a href={mentorMeetLink} target="_blank" rel="noopener noreferrer">{mentorMeetLink}</a>
                      : "Not set for this mentor"}
                  </div>

                  <div className="fflex-none mr-6 mt-4  focus:ring-0 flex items-center">
                    Batch Status : {batchdetails && batchdetails.batchProgress}
                  </div>
                  {!editmeetlink && !editbatchstatus ?
                    <div>
                      <div style={{ display: "flex" }}>
                        {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditMeetLink(true)}>Edit Class</button> : ""}
                        {batchdetails && batchdetails.batchProgress === "Scheduled" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Change Status</button> : ""}
                        {batchdetails && batchdetails.batchProgress === "InProgress" ? <button className="btn btn-secondary mt-4 mr-4" onClick={() => setEditBatchStatus(true)}>Edit Batch Status</button> : ""}
                        {!addStudentClicked && userType === "admin" && batchdetails &&
                          (batchdetails.batchProgress === "Scheduled" || batchdetails.batchProgress === "InProgress") ? (
                          <button className="btn btn-secondary mt-4 mr-4" onClick={selectStudent}>
                            Add Student
                          </button>
                        ) : ""}


                      </div>
                      {userType === "admin" ? addStudentClicked && enableSubmitAddStudentButton ? <button className="btn btn-secondary mt-4 mr-4" onClick={addStudentToTheBatch}>Submit</button> : "" : ""}
                      {userType === "admin" ? addStudentClicked ? <button className="btn btn-secondary mt-4 mr-4" onClick={cancelAddingStudentToTheBatch}>Cancel</button> : "" : ""}


                    </div>
                    : editmeetlink && !editbatchstatus ?
                      <div>

                        <select
                          className="from-control focus:ring-0 mt-4 bg-[#ECECEC]"
                          onChange={(e) => {
                            console.log("tr", e.target.value)
                            const indclass = e.target.value && batchdetails.ClassSchedule.filter(obj => obj.scheduleNumber === parseInt(e.target.value))[0];
                            setClassStatus(indclass ? indclass["status"] : "");
                            // CHANGED: the time fields hold only "HH:MM" so they
                            // stay consistent with what the time inputs produce.
                            setStartDateTime(indclass ? indclass["startDateTime"].split("T")[1].slice(0, 5) : "");
                            setSelectedClass(indclass);
                            setEndDateTime(indclass ? indclass["endDateTime"].split("T")[1].slice(0, 5) : "");
                            setEditDate(indclass ? indclass["startDateTime"] : "");
                          }}
                          required>
                          <option key="" value="">Select Class</option>
                          {batchdetails && batchdetails.ClassSchedule.map((item1, index) => (
                            <option key={item1.scheduleNumber} value={item1.scheduleNumber}>{item1.startDateTime.split("T")[0]}</option>
                          ))}
                        </select>
                        <input
                          type="date"
                          className="from-control mt-4"
                          value={editDate ? editDate.split("T")[0] : ""}
                          onChange={(e) =>
                            setEditDate(e.target.value)}
                        />
                        {/* Meet Link input removed — link is per-mentor now, shown read-only above */}
                        {/* CHANGED: value is the "HH:MM" string directly (was .split("T")[1]) */}
                        <input
                          type="time"
                          className="from-control mt-4"
                          value={startDateTime || ""}
                          onChange={(e) =>
                            setStartDateTime(e.target.value)}
                        />
                        <input
                          type="time"
                          className="from-control mt-4"
                          value={endDateTime || ""}
                          onChange={(e) =>
                            setEndDateTime(e.target.value)}
                        />
                        <div className="input-container">
                          <select
                            className="from-control p-4 bg-[#ECECEC] text-[#827878] mt-4"
                            value={classstatus}
                            onChange={(e) => setClassStatus(e.target.value)}
                            required
                          >
                            <option key="Scheduled" value="Scheduled">Scheduled</option>
                            <option key="InProgress" value="InProgress">InProgress</option>
                            <option key="Completed" value="Completed">Completed</option>
                            {/* NEW: cancelling here asks for a reschedule date */}
                            <option key="Cancelled" value="Cancelled">Cancelled</option>
                          </select>
                        </div>
                        {selectedClass ? "" : <button className="btn btn-black mt-4 mr-4" onClick={() => setEditMeetLink(false)}>Cancel</button>}

                        {selectedClass ? selectedClass.status !== classstatus ?
                          <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
                            <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : selectedClass.startDateTime.split("T")[0] === editDate ? "" : <div> <button className="btn btn-black mt-4 mr-4" onClick={savechanges} >Save Changes</button>
                              <button className="btn btn-black mt-4 mr-4" onClick={cancelEditChanges}>Cancel</button></div> : ""}
                      </div> :
                      !editmeetlink && editbatchstatus ?
                        <div>
                          <div className="input-container">
                            <select
                              className="from-control p-4 bg-[#ECECEC] text-[#827878] "
                              value={status}
                              onChange={(e) => setStatus(e.target.value)}
                              required
                            >
                              {batchdetails.batchProgress === "Scheduled" ? <option key="" value="">Scheduled</option> : ""}
                              {batchdetails.batchProgress === "Scheduled" ? <option key="InProgress" value="InProgress">InProgress</option> : ""}
                              {batchdetails.batchProgress === "Scheduled" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}

                              {batchdetails.batchProgress === "InProgress" ? <option key="" value="">InProgress</option> : ""}
                              {isCompletedVisible && (
                                <option key="Completed" value="Completed">Completed</option>
                              )}
                              {batchdetails.batchProgress === "InProgress" ? <option key="Cancelled" value="Cancelled">Cancelled</option> : ""}


                            </select>


                          </div>
                          <button
                            className=" btn btn-black mr-2 mt-2"
                            onClick={() => setEditBatchStatus(false)}
                          >
                            Cancel
                          </button>
                          {status ? <button className="btn btn-black mt-4 mr-4" onClick={() => UpdateBatchProgress(status)}  >Save Changes</button> : ""}
                        </div >
                        :
                        ""
                  }

                </div>

              </div>
              <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                {addStudentClicked ? <div className="bg-white shadow-box7 p-8 rounded-md">
                  <Input
                    placeholder="Search by Name or Phone number"
                    className="from-control"
                    value={searchValue}
                    onChange={handleSearch}
                    style={{ marginBottom: 16 }}

                  />
                  <Table
                    rowSelection={enrolledrowSelection}
                    className=""
                    columns={columnss}
                    dataSource={filteredData}
                    pagination={filteredData.length > 9 ? true : false}
                    rowKey={(record) => record.key}
                  />
                </div>
                  : <div className="bg-white shadow-box7 p-8 rounded-md">

                    <Table
                      className=""
                      columns={columns}
                      dataSource={batchdetails && batchdetails.StudentsEndrolled}
                      pagination={batchdetails && batchdetails.StudentsEndrolled.length > 9 ? true : false}
                      rowKey={(record) => record.key}
                    />

                  </div>}
              </div>

            </div>
            <div className="bg-white shadow-box7 p-8 rounded-md mt-4">
              <Table
                className=""
                columns={columnsClassSchedule}
                dataSource={batchdetails && batchdetails.ClassSchedule}
                pagination={batchdetails && batchdetails.ClassSchedule.length > 9 ? true : false}
                rowKey={(record) => record.scheduleNumber}
              />
            </div>
          </div>
        </div >}

    </>
  )

}
export default EditBatch;